/*! js-cookie v3.0.5 | MIT */
function xe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var o in n)
      t[o] = n[o];
  }
  return t;
}
var wn = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function ze(t, e) {
  function n(r, i, s) {
    if (!(typeof document > "u")) {
      s = xe({}, e, s), typeof s.expires == "number" && (s.expires = new Date(Date.now() + s.expires * 864e5)), s.expires && (s.expires = s.expires.toUTCString()), r = encodeURIComponent(r).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var a = "";
      for (var f in s)
        s[f] && (a += "; " + f, s[f] !== !0 && (a += "=" + s[f].split(";")[0]));
      return document.cookie = r + "=" + t.write(i, r) + a;
    }
  }
  function o(r) {
    if (!(typeof document > "u" || arguments.length && !r)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], s = {}, a = 0; a < i.length; a++) {
        var f = i[a].split("="), c = f.slice(1).join("=");
        try {
          var g = decodeURIComponent(f[0]);
          if (s[g] = t.read(c, g), r === g)
            break;
        } catch {
        }
      }
      return r ? s[r] : s;
    }
  }
  return Object.create(
    {
      set: n,
      get: o,
      remove: function(r, i) {
        n(
          r,
          "",
          xe({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(r) {
        return ze(this.converter, xe({}, this.attributes, r));
      },
      withConverter: function(r) {
        return ze(xe({}, this.converter, r), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
var se = ze(wn, { path: "/" });
const kn = (t, e, n) => {
  se.set(`reflag-prompt-${t}`, e, {
    expires: n,
    sameSite: "strict",
    secure: !0
  });
}, Cn = (t, e) => (se.get(`reflag-prompt-${t}`) || se.get(`bucket-prompt-${t}`)) === e, Sn = (t, e, n, o) => {
  se.set(`reflag-token-${t}`, JSON.stringify({ channel: e, token: n }), {
    expires: o,
    sameSite: "strict",
    secure: !0
  });
}, Dt = (t) => {
  const e = se.get(`reflag-token-${t}`);
  if (e)
    try {
      const { channel: n, token: o } = JSON.parse(e);
      return !(n != null && n.length) || !(o != null && o.length) ? void 0 : {
        channel: n,
        token: o
      };
    } catch {
      return;
    }
}, Fn = (t) => {
  se.remove(`reflag-token-${t}`);
}, Rn = {
  debug(t) {
  },
  info(t) {
  },
  warn(t, ...e) {
    console.warn(t, ...e);
  },
  error(t, ...e) {
    console.error(t, ...e);
  }
};
function Je(t, e) {
  return {
    debug(n, ...o) {
      t.debug(`${e} ${n}`, ...o);
    },
    info(n, ...o) {
      t.info(`${e} ${n}`, ...o);
    },
    warn(n, ...o) {
      t.warn(`${e} ${n}`, ...o);
    },
    error(n, ...o) {
      t.error(`${e} ${n}`, ...o);
    }
  };
}
const En = 4e4, In = 49999;
class Ln {
  constructor(e, n, o, r, i, s) {
    this.userId = e, this.channel = n, this.sseBaseUrl = o, this.messageHandler = r, this.httpClient = i, this.isOpen = !1, this.eventSource = null, this.retryInterval = null, this.logger = Je(s, "[SSE]"), this.sseBaseUrl.endsWith("/") || (this.sseBaseUrl += "/");
  }
  async refreshTokenRequest() {
    const e = new URLSearchParams({ userId: this.userId }), n = await this.httpClient.get({
      path: "/feedback/prompting-auth",
      params: e
    });
    if (n.ok) {
      const o = await n.json();
      if (o.success) {
        delete o.success;
        const r = o;
        return this.logger.debug("obtained new token request", r), r;
      }
    }
    this.logger.error("server did not release a token request", n);
  }
  async refreshToken() {
    const e = Dt(this.userId);
    if (e && e.channel === this.channel)
      return this.logger.debug("using existing token", e.channel, e.token), e.token;
    const n = await this.refreshTokenRequest();
    if (!n)
      return;
    const o = new URL(
      `keys/${encodeURIComponent(n.keyName)}/requestToken`,
      this.sseBaseUrl
    ), r = await fetch(o, {
      method: "post",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(n)
    });
    if (r.ok) {
      const i = await r.json();
      return this.logger.debug("obtained new token", i), Sn(
        this.userId,
        this.channel,
        i.token,
        new Date(i.expires)
      ), i.token;
    }
    this.logger.error("server did not release a token");
  }
  async onError(e) {
    var n;
    if (e instanceof MessageEvent) {
      let o;
      try {
        const r = JSON.parse(e.data);
        o = (r == null ? void 0 : r.code) && Number(r.code);
      } catch (r) {
        this.logger.warn("received unparsable error message", r, e);
      }
      o && o >= En && o <= In && (this.logger.warn("event source token expired, refresh required"), Fn(this.userId));
    } else {
      const o = (n = e == null ? void 0 : e.target) == null ? void 0 : n.readyState;
      o === 2 ? this.logger.debug("event source connection closed", e) : o === 1 ? this.logger.warn("event source connection failed to open", e) : this.logger.warn("event source unexpected error occurred", e);
    }
    this.disconnect();
  }
  onMessage(e) {
    let n;
    try {
      if (e.data) {
        const o = JSON.parse(e.data);
        o.data && (n = JSON.parse(o.data));
      }
    } catch (o) {
      this.logger.warn("received unparsable message", o, e);
      return;
    }
    if (n) {
      this.logger.debug("received message", n);
      try {
        this.messageHandler(n);
      } catch (o) {
        this.logger.warn("failed to handle message", o, n);
      }
      return;
    }
    this.logger.warn("received invalid message", e);
  }
  onOpen(e) {
    this.logger.debug("event source connection opened", e);
  }
  async connect() {
    if (this.isOpen) {
      this.logger.warn("channel connection already open");
      return;
    }
    this.isOpen = !0;
    try {
      const e = await this.refreshToken();
      if (!e) return;
      const n = new URL("sse", this.sseBaseUrl);
      n.searchParams.append("v", "1.2"), n.searchParams.append("accessToken", e), n.searchParams.append("channels", this.channel), n.searchParams.append("rewind", "1"), this.eventSource = new EventSource(n), this.eventSource.addEventListener("error", (o) => this.onError(o)), this.eventSource.addEventListener("open", (o) => this.onOpen(o)), this.eventSource.addEventListener("message", (o) => this.onMessage(o)), this.logger.debug("channel connection opened");
    } finally {
      this.isOpen = !!this.eventSource;
    }
  }
  disconnect() {
    if (!this.isOpen) {
      this.logger.warn("channel connection already closed");
      return;
    }
    this.eventSource && (this.eventSource.close(), this.eventSource = null, this.logger.debug("channel connection closed")), this.isOpen = !1;
  }
  open(e) {
    const n = (e == null ? void 0 : e.retryInterval) ?? 3e4, o = (e == null ? void 0 : e.retryCount) ?? 3;
    let r = o;
    const i = async () => {
      try {
        await this.connect(), r = o;
      } catch (s) {
        r > 0 ? this.logger.warn(
          `failed to connect, ${r} retries remaining`,
          s
        ) : this.logger.warn("failed to connect, no retries remaining", s);
      }
    };
    i(), this.retryInterval = setInterval(() => {
      if (!this.isConnected() && this.retryInterval) {
        if (r <= 0) {
          clearInterval(this.retryInterval), this.retryInterval = null;
          return;
        }
        r--, i();
      }
    }, n);
  }
  close() {
    this.retryInterval && (clearInterval(this.retryInterval), this.retryInterval = null), this.disconnect();
  }
  isActive() {
    return !!this.retryInterval;
  }
  isConnected() {
    return this.isOpen && !!this.eventSource;
  }
}
function On({
  userId: t,
  channel: e,
  callback: n,
  httpClient: o,
  sseBaseUrl: r,
  logger: i
}) {
  const s = new Ln(
    t,
    e,
    r,
    n,
    o,
    i
  );
  return s.open(), s;
}
const An = (t) => {
  if (!(typeof (t == null ? void 0 : t.question) != "string" || !t.question.length || typeof t.showAfter != "number" || typeof t.showBefore != "number" || typeof t.promptId != "string" || !t.promptId.length || typeof t.featureId != "string" || !t.featureId.length))
    return {
      question: t.question,
      showAfter: new Date(t.showAfter),
      showBefore: new Date(t.showBefore),
      promptId: t.promptId,
      featureId: t.featureId
    };
}, Tn = (t, e, n) => {
  const o = /* @__PURE__ */ new Date(), r = () => {
    kn(t, e.promptId, e.showBefore);
  };
  return Cn(t, e.promptId) || o > e.showBefore ? !1 : o < e.showAfter ? (setTimeout(() => {
    n(t, e, r);
  }, e.showAfter.getTime() - o.getTime()), !0) : (n(t, e, r), !0);
};
var Me, E, $t, G, lt, Ut, Be, Xe, Ve, je, pe = {}, Nt = [], Mn = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, Ge = Array.isArray;
function Y(t, e) {
  for (var n in e) t[n] = e[n];
  return t;
}
function Ht(t) {
  var e = t.parentNode;
  e && e.removeChild(t);
}
function d(t, e, n) {
  var o, r, i, s = {};
  for (i in e) i == "key" ? o = e[i] : i == "ref" ? r = e[i] : s[i] = e[i];
  if (arguments.length > 2 && (s.children = arguments.length > 3 ? Me.call(arguments, 2) : n), typeof t == "function" && t.defaultProps != null) for (i in t.defaultProps) s[i] === void 0 && (s[i] = t.defaultProps[i]);
  return Se(t, s, o, r, null);
}
function Se(t, e, n, o, r) {
  var i = { type: t, props: e, key: n, ref: o, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: r ?? ++$t, __i: -1, __u: 0 };
  return r == null && E.vnode != null && E.vnode(i), i;
}
function z(t) {
  return t.children;
}
function Fe(t, e) {
  this.props = t, this.context = e;
}
function te(t, e) {
  if (e == null) return t.__ ? te(t.__, t.__i + 1) : null;
  for (var n; e < t.__k.length; e++) if ((n = t.__k[e]) != null && n.__e != null) return n.__e;
  return typeof t.type == "function" ? te(t) : null;
}
function zt(t) {
  var e, n;
  if ((t = t.__) != null && t.__c != null) {
    for (t.__e = t.__c.base = null, e = 0; e < t.__k.length; e++) if ((n = t.__k[e]) != null && n.__e != null) {
      t.__e = t.__c.base = n.__e;
      break;
    }
    return zt(t);
  }
}
function ct(t) {
  (!t.__d && (t.__d = !0) && G.push(t) && !Ie.__r++ || lt !== E.debounceRendering) && ((lt = E.debounceRendering) || Ut)(Ie);
}
function Ie() {
  var t, e, n, o, r, i, s, a;
  for (G.sort(Be); t = G.shift(); ) t.__d && (e = G.length, o = void 0, i = (r = (n = t).__v).__e, s = [], a = [], n.__P && ((o = Y({}, r)).__v = r.__v + 1, E.vnode && E.vnode(o), Qe(n.__P, o, r, n.__n, n.__P.namespaceURI, 32 & r.__u ? [i] : null, s, i ?? te(r), !!(32 & r.__u), a), o.__v = r.__v, o.__.__k[o.__i] = o, jt(s, o, a), o.__e != i && zt(o)), G.length > e && G.sort(Be));
  Ie.__r = 0;
}
function Bt(t, e, n, o, r, i, s, a, f, c, g) {
  var l, h, u, m, _, b = o && o.__k || Nt, p = e.length;
  for (n.__d = f, Pn(n, e, b), f = n.__d, l = 0; l < p; l++) (u = n.__k[l]) != null && typeof u != "boolean" && typeof u != "function" && (h = u.__i === -1 ? pe : b[u.__i] || pe, u.__i = l, Qe(t, u, h, r, i, s, a, f, c, g), m = u.__e, u.ref && h.ref != u.ref && (h.ref && et(h.ref, null, u), g.push(u.ref, u.__c || m, u)), _ == null && m != null && (_ = m), 65536 & u.__u || h.__k === u.__k ? (f && typeof u.type == "string" && !t.contains(f) && (f = te(h)), f = Vt(u, f, t)) : typeof u.type == "function" && u.__d !== void 0 ? f = u.__d : m && (f = m.nextSibling), u.__d = void 0, u.__u &= -196609);
  n.__d = f, n.__e = _;
}
function Pn(t, e, n) {
  var o, r, i, s, a, f = e.length, c = n.length, g = c, l = 0;
  for (t.__k = [], o = 0; o < f; o++) s = o + l, (r = t.__k[o] = (r = e[o]) == null || typeof r == "boolean" || typeof r == "function" ? null : typeof r == "string" || typeof r == "number" || typeof r == "bigint" || r.constructor == String ? Se(null, r, null, null, null) : Ge(r) ? Se(z, { children: r }, null, null, null) : r.constructor === void 0 && r.__b > 0 ? Se(r.type, r.props, r.key, r.ref ? r.ref : null, r.__v) : r) != null ? (r.__ = t, r.__b = t.__b + 1, a = Dn(r, n, s, g), r.__i = a, i = null, a !== -1 && (g--, (i = n[a]) && (i.__u |= 131072)), i == null || i.__v === null ? (a == -1 && l--, typeof r.type != "function" && (r.__u |= 65536)) : a !== s && (a == s - 1 ? l = a - s : a == s + 1 ? l++ : a > s ? g > f - s ? l += a - s : l-- : a < s && l++, a !== o + l && (r.__u |= 65536))) : (i = n[s]) && i.key == null && i.__e && !(131072 & i.__u) && (i.__e == t.__d && (t.__d = te(i)), Ke(i, i, !1), n[s] = null, g--);
  if (g) for (o = 0; o < c; o++) (i = n[o]) != null && !(131072 & i.__u) && (i.__e == t.__d && (t.__d = te(i)), Ke(i, i));
}
function Vt(t, e, n) {
  var o, r;
  if (typeof t.type == "function") {
    for (o = t.__k, r = 0; o && r < o.length; r++) o[r] && (o[r].__ = t, e = Vt(o[r], e, n));
    return e;
  }
  t.__e != e && (n.insertBefore(t.__e, e || null), e = t.__e);
  do
    e = e && e.nextSibling;
  while (e != null && e.nodeType === 8);
  return e;
}
function Dn(t, e, n, o) {
  var r = t.key, i = t.type, s = n - 1, a = n + 1, f = e[n];
  if (f === null || f && r == f.key && i === f.type && !(131072 & f.__u)) return n;
  if (o > (f != null && !(131072 & f.__u) ? 1 : 0)) for (; s >= 0 || a < e.length; ) {
    if (s >= 0) {
      if ((f = e[s]) && !(131072 & f.__u) && r == f.key && i === f.type) return s;
      s--;
    }
    if (a < e.length) {
      if ((f = e[a]) && !(131072 & f.__u) && r == f.key && i === f.type) return a;
      a++;
    }
  }
  return -1;
}
function ft(t, e, n) {
  e[0] === "-" ? t.setProperty(e, n ?? "") : t[e] = n == null ? "" : typeof n != "number" || Mn.test(e) ? n : n + "px";
}
function we(t, e, n, o, r) {
  var i;
  e: if (e === "style") if (typeof n == "string") t.style.cssText = n;
  else {
    if (typeof o == "string" && (t.style.cssText = o = ""), o) for (e in o) n && e in n || ft(t.style, e, "");
    if (n) for (e in n) o && n[e] === o[e] || ft(t.style, e, n[e]);
  }
  else if (e[0] === "o" && e[1] === "n") i = e !== (e = e.replace(/(PointerCapture)$|Capture$/i, "$1")), e = e.toLowerCase() in t || e === "onFocusOut" || e === "onFocusIn" ? e.toLowerCase().slice(2) : e.slice(2), t.l || (t.l = {}), t.l[e + i] = n, n ? o ? n.u = o.u : (n.u = Xe, t.addEventListener(e, i ? je : Ve, i)) : t.removeEventListener(e, i ? je : Ve, i);
  else {
    if (r == "http://www.w3.org/2000/svg") e = e.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if (e != "width" && e != "height" && e != "href" && e != "list" && e != "form" && e != "tabIndex" && e != "download" && e != "rowSpan" && e != "colSpan" && e != "role" && e != "popover" && e in t) try {
      t[e] = n ?? "";
      break e;
    } catch {
    }
    typeof n == "function" || (n == null || n === !1 && e[4] !== "-" ? t.removeAttribute(e) : t.setAttribute(e, e == "popover" && n == 1 ? "" : n));
  }
}
function dt(t) {
  return function(e) {
    if (this.l) {
      var n = this.l[e.type + t];
      if (e.t == null) e.t = Xe++;
      else if (e.t < n.u) return;
      return n(E.event ? E.event(e) : e);
    }
  };
}
function Qe(t, e, n, o, r, i, s, a, f, c) {
  var g, l, h, u, m, _, b, p, y, v, w, x, k, S, I, T, C = e.type;
  if (e.constructor !== void 0) return null;
  128 & n.__u && (f = !!(32 & n.__u), i = [a = e.__e = n.__e]), (g = E.__b) && g(e);
  e: if (typeof C == "function") try {
    if (p = e.props, y = "prototype" in C && C.prototype.render, v = (g = C.contextType) && o[g.__c], w = g ? v ? v.props.value : g.__ : o, n.__c ? b = (l = e.__c = n.__c).__ = l.__E : (y ? e.__c = l = new C(p, w) : (e.__c = l = new Fe(p, w), l.constructor = C, l.render = Un), v && v.sub(l), l.props = p, l.state || (l.state = {}), l.context = w, l.__n = o, h = l.__d = !0, l.__h = [], l._sb = []), y && l.__s == null && (l.__s = l.state), y && C.getDerivedStateFromProps != null && (l.__s == l.state && (l.__s = Y({}, l.__s)), Y(l.__s, C.getDerivedStateFromProps(p, l.__s))), u = l.props, m = l.state, l.__v = e, h) y && C.getDerivedStateFromProps == null && l.componentWillMount != null && l.componentWillMount(), y && l.componentDidMount != null && l.__h.push(l.componentDidMount);
    else {
      if (y && C.getDerivedStateFromProps == null && p !== u && l.componentWillReceiveProps != null && l.componentWillReceiveProps(p, w), !l.__e && (l.shouldComponentUpdate != null && l.shouldComponentUpdate(p, l.__s, w) === !1 || e.__v === n.__v)) {
        for (e.__v !== n.__v && (l.props = p, l.state = l.__s, l.__d = !1), e.__e = n.__e, e.__k = n.__k, e.__k.forEach(function(M) {
          M && (M.__ = e);
        }), x = 0; x < l._sb.length; x++) l.__h.push(l._sb[x]);
        l._sb = [], l.__h.length && s.push(l);
        break e;
      }
      l.componentWillUpdate != null && l.componentWillUpdate(p, l.__s, w), y && l.componentDidUpdate != null && l.__h.push(function() {
        l.componentDidUpdate(u, m, _);
      });
    }
    if (l.context = w, l.props = p, l.__P = t, l.__e = !1, k = E.__r, S = 0, y) {
      for (l.state = l.__s, l.__d = !1, k && k(e), g = l.render(l.props, l.state, l.context), I = 0; I < l._sb.length; I++) l.__h.push(l._sb[I]);
      l._sb = [];
    } else do
      l.__d = !1, k && k(e), g = l.render(l.props, l.state, l.context), l.state = l.__s;
    while (l.__d && ++S < 25);
    l.state = l.__s, l.getChildContext != null && (o = Y(Y({}, o), l.getChildContext())), y && !h && l.getSnapshotBeforeUpdate != null && (_ = l.getSnapshotBeforeUpdate(u, m)), Bt(t, Ge(T = g != null && g.type === z && g.key == null ? g.props.children : g) ? T : [T], e, n, o, r, i, s, a, f, c), l.base = e.__e, e.__u &= -161, l.__h.length && s.push(l), b && (l.__E = l.__ = null);
  } catch (M) {
    e.__v = null, f || i != null ? (e.__e = a, e.__u |= f ? 160 : 32, i[i.indexOf(a)] = null) : (e.__e = n.__e, e.__k = n.__k), E.__e(M, e, n);
  }
  else i == null && e.__v === n.__v ? (e.__k = n.__k, e.__e = n.__e) : e.__e = $n(n.__e, e, n, o, r, i, s, f, c);
  (g = E.diffed) && g(e);
}
function jt(t, e, n) {
  e.__d = void 0;
  for (var o = 0; o < n.length; o++) et(n[o], n[++o], n[++o]);
  E.__c && E.__c(e, t), t.some(function(r) {
    try {
      t = r.__h, r.__h = [], t.some(function(i) {
        i.call(r);
      });
    } catch (i) {
      E.__e(i, r.__v);
    }
  });
}
function $n(t, e, n, o, r, i, s, a, f) {
  var c, g, l, h, u, m, _, b = n.props, p = e.props, y = e.type;
  if (y === "svg" ? r = "http://www.w3.org/2000/svg" : y === "math" ? r = "http://www.w3.org/1998/Math/MathML" : r || (r = "http://www.w3.org/1999/xhtml"), i != null) {
    for (c = 0; c < i.length; c++) if ((u = i[c]) && "setAttribute" in u == !!y && (y ? u.localName === y : u.nodeType === 3)) {
      t = u, i[c] = null;
      break;
    }
  }
  if (t == null) {
    if (y === null) return document.createTextNode(p);
    t = document.createElementNS(r, y, p.is && p), i = null, a = !1;
  }
  if (y === null) b === p || a && t.data === p || (t.data = p);
  else {
    if (i = i && Me.call(t.childNodes), b = n.props || pe, !a && i != null) for (b = {}, c = 0; c < t.attributes.length; c++) b[(u = t.attributes[c]).name] = u.value;
    for (c in b) if (u = b[c], c != "children") {
      if (c == "dangerouslySetInnerHTML") l = u;
      else if (c !== "key" && !(c in p)) {
        if (c == "value" && "defaultValue" in p || c == "checked" && "defaultChecked" in p) continue;
        we(t, c, null, u, r);
      }
    }
    for (c in p) u = p[c], c == "children" ? h = u : c == "dangerouslySetInnerHTML" ? g = u : c == "value" ? m = u : c == "checked" ? _ = u : c === "key" || a && typeof u != "function" || b[c] === u || we(t, c, u, b[c], r);
    if (g) a || l && (g.__html === l.__html || g.__html === t.innerHTML) || (t.innerHTML = g.__html), e.__k = [];
    else if (l && (t.innerHTML = ""), Bt(t, Ge(h) ? h : [h], e, n, o, y === "foreignObject" ? "http://www.w3.org/1999/xhtml" : r, i, s, i ? i[0] : n.__k && te(n, 0), a, f), i != null) for (c = i.length; c--; ) i[c] != null && Ht(i[c]);
    a || (c = "value", m !== void 0 && (m !== t[c] || y === "progress" && !m || y === "option" && m !== b[c]) && we(t, c, m, b[c], r), c = "checked", _ !== void 0 && _ !== t[c] && we(t, c, _, b[c], r));
  }
  return t;
}
function et(t, e, n) {
  try {
    typeof t == "function" ? t(e) : t.current = e;
  } catch (o) {
    E.__e(o, n);
  }
}
function Ke(t, e, n) {
  var o, r;
  if (E.unmount && E.unmount(t), (o = t.ref) && (o.current && o.current !== t.__e || et(o, null, e)), (o = t.__c) != null) {
    if (o.componentWillUnmount) try {
      o.componentWillUnmount();
    } catch (i) {
      E.__e(i, e);
    }
    o.base = o.__P = null;
  }
  if (o = t.__k) for (r = 0; r < o.length; r++) o[r] && Ke(o[r], e, n || typeof t.type != "function");
  n || t.__e == null || Ht(t.__e), t.__c = t.__ = t.__e = t.__d = void 0;
}
function Un(t, e, n) {
  return this.constructor(t, n);
}
function Kt(t, e, n) {
  var o, r, i, s;
  E.__ && E.__(t, e), r = (o = typeof n == "function") ? null : e.__k, i = [], s = [], Qe(e, t = (!o && n || e).__k = d(z, null, [t]), r || pe, pe, e.namespaceURI, !o && n ? [n] : r ? null : e.firstChild ? Me.call(e.childNodes) : null, i, !o && n ? n : r ? r.__e : e.firstChild, o, s), jt(i, t, s);
}
Me = Nt.slice, E = { __e: function(t, e, n, o) {
  for (var r, i, s; e = e.__; ) if ((r = e.__c) && !r.__) try {
    if ((i = r.constructor) && i.getDerivedStateFromError != null && (r.setState(i.getDerivedStateFromError(t)), s = r.__d), r.componentDidCatch != null && (r.componentDidCatch(t, o || {}), s = r.__d), s) return r.__E = r;
  } catch (a) {
    t = a;
  }
  throw t;
} }, $t = 0, Fe.prototype.setState = function(t, e) {
  var n;
  n = this.__s != null && this.__s !== this.state ? this.__s : this.__s = Y({}, this.state), typeof t == "function" && (t = t(Y({}, n), this.props)), t && Y(n, t), t != null && this.__v && (e && this._sb.push(e), ct(this));
}, Fe.prototype.forceUpdate = function(t) {
  this.__v && (this.__e = !0, t && this.__h.push(t), ct(this));
}, Fe.prototype.render = z, G = [], Ut = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Be = function(t, e) {
  return t.__v.__b - e.__v.__b;
}, Ie.__r = 0, Xe = 0, Ve = dt(!1), je = dt(!0);
const Ze = "reflag-feedback-dialog-container", Zt = "reflag-toolbar-dialog-container", Wt = [
  "animationcancel",
  "animationend",
  "animationiteration",
  "animationstart",
  "afterscriptexecute",
  "auxclick",
  "beforescriptexecute",
  "blur",
  "click",
  "compositionend",
  "compositionstart",
  "compositionupdate",
  "contextmenu",
  "copy",
  "cut",
  "dblclick",
  "DOMActivate",
  "DOMMouseScroll",
  "error",
  "focusin",
  "focusout",
  "focus",
  "fullscreenchange",
  "fullscreenerror",
  "gesturechange",
  "gestureend",
  "gesturestart",
  "gotpointercapture",
  "keydown",
  "keypress",
  "keyup",
  "lostpointercapture",
  "mousedown",
  "mouseenter",
  "mouseleave",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "mousewheel",
  "paste",
  "pointercancel",
  "pointerdown",
  "pointerenter",
  "pointerleave",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "scroll",
  "select",
  "touchcancel",
  "touchend",
  "touchmove",
  "touchstart",
  "transitioncancel",
  "transitionend",
  "transitionrun",
  "transitionstart",
  "wheel"
];
var ae, L, Ue, ut, me = 0, qt = [], O = E, gt = O.__b, ht = O.__r, pt = O.diffed, mt = O.__c, bt = O.unmount, _t = O.__;
function Pe(t, e) {
  O.__h && O.__h(L, t, me || e), me = 0;
  var n = L.__H || (L.__H = { __: [], __h: [] });
  return t >= n.__.length && n.__.push({}), n.__[t];
}
function A(t) {
  return me = 1, Nn(Yt, t);
}
function Nn(t, e, n) {
  var o = Pe(ae++, 2);
  if (o.t = t, !o.__c && (o.__ = [Yt(void 0, e), function(a) {
    var f = o.__N ? o.__N[0] : o.__[0], c = o.t(f, a);
    f !== c && (o.__N = [c, o.__[1]], o.__c.setState({}));
  }], o.__c = L, !L.u)) {
    var r = function(a, f, c) {
      if (!o.__c.__H) return !0;
      var g = o.__c.__H.__.filter(function(h) {
        return !!h.__c;
      });
      if (g.every(function(h) {
        return !h.__N;
      })) return !i || i.call(this, a, f, c);
      var l = !1;
      return g.forEach(function(h) {
        if (h.__N) {
          var u = h.__[0];
          h.__ = h.__N, h.__N = void 0, u !== h.__[0] && (l = !0);
        }
      }), !(!l && o.__c.props === a) && (!i || i.call(this, a, f, c));
    };
    L.u = !0;
    var i = L.shouldComponentUpdate, s = L.componentWillUpdate;
    L.componentWillUpdate = function(a, f, c) {
      if (this.__e) {
        var g = i;
        i = void 0, r(a, f, c), i = g;
      }
      s && s.call(this, a, f, c);
    }, L.shouldComponentUpdate = r;
  }
  return o.__N || o.__;
}
function le(t, e) {
  var n = Pe(ae++, 3);
  !O.__s && tt(n.__H, e) && (n.__ = t, n.i = e, L.__H.__h.push(n));
}
function Re(t, e) {
  var n = Pe(ae++, 4);
  !O.__s && tt(n.__H, e) && (n.__ = t, n.i = e, L.__h.push(n));
}
function U(t) {
  return me = 5, Q(function() {
    return { current: t };
  }, []);
}
function Q(t, e) {
  var n = Pe(ae++, 7);
  return tt(n.__H, e) && (n.__ = t(), n.__H = e, n.__h = t), n.__;
}
function P(t, e) {
  return me = 8, Q(function() {
    return t;
  }, e);
}
function Hn() {
  for (var t; t = qt.shift(); ) if (t.__P && t.__H) try {
    t.__H.__h.forEach(Ee), t.__H.__h.forEach(We), t.__H.__h = [];
  } catch (e) {
    t.__H.__h = [], O.__e(e, t.__v);
  }
}
O.__b = function(t) {
  L = null, gt && gt(t);
}, O.__ = function(t, e) {
  t && e.__k && e.__k.__m && (t.__m = e.__k.__m), _t && _t(t, e);
}, O.__r = function(t) {
  ht && ht(t), ae = 0;
  var e = (L = t.__c).__H;
  e && (Ue === L ? (e.__h = [], L.__h = [], e.__.forEach(function(n) {
    n.__N && (n.__ = n.__N), n.i = n.__N = void 0;
  })) : (e.__h.forEach(Ee), e.__h.forEach(We), e.__h = [], ae = 0)), Ue = L;
}, O.diffed = function(t) {
  pt && pt(t);
  var e = t.__c;
  e && e.__H && (e.__H.__h.length && (qt.push(e) !== 1 && ut === O.requestAnimationFrame || ((ut = O.requestAnimationFrame) || zn)(Hn)), e.__H.__.forEach(function(n) {
    n.i && (n.__H = n.i), n.i = void 0;
  })), Ue = L = null;
}, O.__c = function(t, e) {
  e.some(function(n) {
    try {
      n.__h.forEach(Ee), n.__h = n.__h.filter(function(o) {
        return !o.__ || We(o);
      });
    } catch (o) {
      e.some(function(r) {
        r.__h && (r.__h = []);
      }), e = [], O.__e(o, n.__v);
    }
  }), mt && mt(t, e);
}, O.unmount = function(t) {
  bt && bt(t);
  var e, n = t.__c;
  n && n.__H && (n.__H.__.forEach(function(o) {
    try {
      Ee(o);
    } catch (r) {
      e = r;
    }
  }), n.__H = void 0, e && O.__e(e, n.__v));
};
var yt = typeof requestAnimationFrame == "function";
function zn(t) {
  var e, n = function() {
    clearTimeout(o), yt && cancelAnimationFrame(e), setTimeout(t);
  }, o = setTimeout(n, 100);
  yt && (e = requestAnimationFrame(n));
}
function Ee(t) {
  var e = L, n = t.__c;
  typeof n == "function" && (t.__c = void 0, n()), L = e;
}
function We(t) {
  var e = L;
  t.__c = t.__(), L = e;
}
function tt(t, e) {
  return !t || t.length !== e.length || e.some(function(n, o) {
    return n !== t[o];
  });
}
function Yt(t, e) {
  return typeof e == "function" ? e(t) : e;
}
const ce = Math.min, ee = Math.max, Le = Math.round, ke = Math.floor, J = (t) => ({
  x: t,
  y: t
}), Bn = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Vn = {
  start: "end",
  end: "start"
};
function qe(t, e, n) {
  return ee(t, ce(e, n));
}
function _e(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function ne(t) {
  return t.split("-")[0];
}
function ye(t) {
  return t.split("-")[1];
}
function Jt(t) {
  return t === "x" ? "y" : "x";
}
function nt(t) {
  return t === "y" ? "height" : "width";
}
function fe(t) {
  return ["top", "bottom"].includes(ne(t)) ? "y" : "x";
}
function ot(t) {
  return Jt(fe(t));
}
function jn(t, e, n) {
  n === void 0 && (n = !1);
  const o = ye(t), r = ot(t), i = nt(r);
  let s = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[i] > e.floating[i] && (s = Oe(s)), [s, Oe(s)];
}
function Kn(t) {
  const e = Oe(t);
  return [Ye(t), e, Ye(e)];
}
function Ye(t) {
  return t.replace(/start|end/g, (e) => Vn[e]);
}
function Zn(t, e, n) {
  const o = ["left", "right"], r = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? r : o : e ? o : r;
    case "left":
    case "right":
      return e ? i : s;
    default:
      return [];
  }
}
function Wn(t, e, n, o) {
  const r = ye(t);
  let i = Zn(ne(t), n === "start", o);
  return r && (i = i.map((s) => s + "-" + r), e && (i = i.concat(i.map(Ye)))), i;
}
function Oe(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Bn[e]);
}
function qn(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Xt(t) {
  return typeof t != "number" ? qn(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Ae(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: r
  } = t;
  return {
    width: o,
    height: r,
    top: n,
    left: e,
    right: e + o,
    bottom: n + r,
    x: e,
    y: n
  };
}
function vt(t, e, n) {
  let {
    reference: o,
    floating: r
  } = t;
  const i = fe(e), s = ot(e), a = nt(s), f = ne(e), c = i === "y", g = o.x + o.width / 2 - r.width / 2, l = o.y + o.height / 2 - r.height / 2, h = o[a] / 2 - r[a] / 2;
  let u;
  switch (f) {
    case "top":
      u = {
        x: g,
        y: o.y - r.height
      };
      break;
    case "bottom":
      u = {
        x: g,
        y: o.y + o.height
      };
      break;
    case "right":
      u = {
        x: o.x + o.width,
        y: l
      };
      break;
    case "left":
      u = {
        x: o.x - r.width,
        y: l
      };
      break;
    default:
      u = {
        x: o.x,
        y: o.y
      };
  }
  switch (ye(e)) {
    case "start":
      u[s] -= h * (n && c ? -1 : 1);
      break;
    case "end":
      u[s] += h * (n && c ? -1 : 1);
      break;
  }
  return u;
}
const Yn = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: i = [],
    platform: s
  } = n, a = i.filter(Boolean), f = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let c = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), {
    x: g,
    y: l
  } = vt(c, o, f), h = o, u = {}, m = 0;
  for (let _ = 0; _ < a.length; _++) {
    const {
      name: b,
      fn: p
    } = a[_], {
      x: y,
      y: v,
      data: w,
      reset: x
    } = await p({
      x: g,
      y: l,
      initialPlacement: o,
      placement: h,
      strategy: r,
      middlewareData: u,
      rects: c,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    g = y ?? g, l = v ?? l, u = {
      ...u,
      [b]: {
        ...u[b],
        ...w
      }
    }, x && m <= 50 && (m++, typeof x == "object" && (x.placement && (h = x.placement), x.rects && (c = x.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: r
    }) : x.rects), {
      x: g,
      y: l
    } = vt(c, h, f)), _ = -1);
  }
  return {
    x: g,
    y: l,
    placement: h,
    strategy: r,
    middlewareData: u
  };
};
async function Gt(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: r,
    platform: i,
    rects: s,
    elements: a,
    strategy: f
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: g = "viewport",
    elementContext: l = "floating",
    altBoundary: h = !1,
    padding: u = 0
  } = _e(e, t), m = Xt(u), b = a[h ? l === "floating" ? "reference" : "floating" : l], p = Ae(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(b))) == null || n ? b : b.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: g,
    strategy: f
  })), y = l === "floating" ? {
    x: o,
    y: r,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, v = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), w = await (i.isElement == null ? void 0 : i.isElement(v)) ? await (i.getScale == null ? void 0 : i.getScale(v)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = Ae(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: y,
    offsetParent: v,
    strategy: f
  }) : y);
  return {
    top: (p.top - x.top + m.top) / w.y,
    bottom: (x.bottom - p.bottom + m.bottom) / w.y,
    left: (p.left - x.left + m.left) / w.x,
    right: (x.right - p.right + m.right) / w.x
  };
}
const Jn = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: i,
      platform: s,
      elements: a,
      middlewareData: f
    } = e, {
      element: c,
      padding: g = 0
    } = _e(t, e) || {};
    if (c == null)
      return {};
    const l = Xt(g), h = {
      x: n,
      y: o
    }, u = ot(r), m = nt(u), _ = await s.getDimensions(c), b = u === "y", p = b ? "top" : "left", y = b ? "bottom" : "right", v = b ? "clientHeight" : "clientWidth", w = i.reference[m] + i.reference[u] - h[u] - i.floating[m], x = h[u] - i.reference[u], k = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let S = k ? k[v] : 0;
    (!S || !await (s.isElement == null ? void 0 : s.isElement(k))) && (S = a.floating[v] || i.floating[m]);
    const I = w / 2 - x / 2, T = S / 2 - _[m] / 2 - 1, C = ce(l[p], T), M = ce(l[y], T), H = C, W = S - _[m] - M, R = S / 2 - _[m] / 2 + I, K = qe(H, R, W), F = !f.arrow && ye(r) != null && R !== K && i.reference[m] / 2 - (R < H ? C : M) - _[m] / 2 < 0, D = F ? R < H ? R - H : R - W : 0;
    return {
      [u]: h[u] + D,
      data: {
        [u]: K,
        centerOffset: R - K - D,
        ...F && {
          alignmentOffset: D
        }
      },
      reset: F
    };
  }
}), Xn = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        middlewareData: i,
        rects: s,
        initialPlacement: a,
        platform: f,
        elements: c
      } = e, {
        mainAxis: g = !0,
        crossAxis: l = !0,
        fallbackPlacements: h,
        fallbackStrategy: u = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: _ = !0,
        ...b
      } = _e(t, e);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const p = ne(r), y = fe(a), v = ne(a) === a, w = await (f.isRTL == null ? void 0 : f.isRTL(c.floating)), x = h || (v || !_ ? [Oe(a)] : Kn(a)), k = m !== "none";
      !h && k && x.push(...Wn(a, _, m, w));
      const S = [a, ...x], I = await Gt(e, b), T = [];
      let C = ((o = i.flip) == null ? void 0 : o.overflows) || [];
      if (g && T.push(I[p]), l) {
        const R = jn(r, s, w);
        T.push(I[R[0]], I[R[1]]);
      }
      if (C = [...C, {
        placement: r,
        overflows: T
      }], !T.every((R) => R <= 0)) {
        var M, H;
        const R = (((M = i.flip) == null ? void 0 : M.index) || 0) + 1, K = S[R];
        if (K)
          return {
            data: {
              index: R,
              overflows: C
            },
            reset: {
              placement: K
            }
          };
        let F = (H = C.filter((D) => D.overflows[0] <= 0).sort((D, $) => D.overflows[1] - $.overflows[1])[0]) == null ? void 0 : H.placement;
        if (!F)
          switch (u) {
            case "bestFit": {
              var W;
              const D = (W = C.filter(($) => {
                if (k) {
                  const q = fe($.placement);
                  return q === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  q === "y";
                }
                return !0;
              }).map(($) => [$.placement, $.overflows.filter((q) => q > 0).reduce((q, xn) => q + xn, 0)]).sort(($, q) => $[1] - q[1])[0]) == null ? void 0 : W[0];
              D && (F = D);
              break;
            }
            case "initialPlacement":
              F = a;
              break;
          }
        if (r !== F)
          return {
            reset: {
              placement: F
            }
          };
      }
      return {};
    }
  };
};
async function Gn(t, e) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = t, i = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), s = ne(n), a = ye(n), f = fe(n) === "y", c = ["left", "top"].includes(s) ? -1 : 1, g = i && f ? -1 : 1, l = _e(e, t);
  let {
    mainAxis: h,
    crossAxis: u,
    alignmentAxis: m
  } = typeof l == "number" ? {
    mainAxis: l,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...l
  };
  return a && typeof m == "number" && (u = a === "end" ? m * -1 : m), f ? {
    x: u * g,
    y: h * c
  } : {
    x: h * c,
    y: u * g
  };
}
const Qn = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: r,
        y: i,
        placement: s,
        middlewareData: a
      } = e, f = await Gn(e, t);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (o = a.arrow) != null && o.alignmentOffset ? {} : {
        x: r + f.x,
        y: i + f.y,
        data: {
          ...f,
          placement: s
        }
      };
    }
  };
}, eo = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: r
      } = e, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (b) => {
            let {
              x: p,
              y
            } = b;
            return {
              x: p,
              y
            };
          }
        },
        ...f
      } = _e(t, e), c = {
        x: n,
        y: o
      }, g = await Gt(e, f), l = fe(ne(r)), h = Jt(l);
      let u = c[h], m = c[l];
      if (i) {
        const b = h === "y" ? "top" : "left", p = h === "y" ? "bottom" : "right", y = u + g[b], v = u - g[p];
        u = qe(y, u, v);
      }
      if (s) {
        const b = l === "y" ? "top" : "left", p = l === "y" ? "bottom" : "right", y = m + g[b], v = m - g[p];
        m = qe(y, m, v);
      }
      const _ = a.fn({
        ...e,
        [h]: u,
        [l]: m
      });
      return {
        ..._,
        data: {
          x: _.x - n,
          y: _.y - o
        }
      };
    }
  };
};
function ge(t) {
  return Qt(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function N(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Z(t) {
  var e;
  return (e = (Qt(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Qt(t) {
  return t instanceof Node || t instanceof N(t).Node;
}
function B(t) {
  return t instanceof Element || t instanceof N(t).Element;
}
function j(t) {
  return t instanceof HTMLElement || t instanceof N(t).HTMLElement;
}
function xt(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof N(t).ShadowRoot;
}
function ve(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: r
  } = V(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && !["inline", "contents"].includes(r);
}
function to(t) {
  return ["table", "td", "th"].includes(ge(t));
}
function De(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function rt(t) {
  const e = it(), n = B(t) ? V(t) : t;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function no(t) {
  let e = X(t);
  for (; j(e) && !de(e); ) {
    if (rt(e))
      return e;
    if (De(e))
      return null;
    e = X(e);
  }
  return null;
}
function it() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function de(t) {
  return ["html", "body", "#document"].includes(ge(t));
}
function V(t) {
  return N(t).getComputedStyle(t);
}
function $e(t) {
  return B(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function X(t) {
  if (ge(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    xt(t) && t.host || // Fallback.
    Z(t)
  );
  return xt(e) ? e.host : e;
}
function en(t) {
  const e = X(t);
  return de(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : j(e) && ve(e) ? e : en(e);
}
function be(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = en(t), i = r === ((o = t.ownerDocument) == null ? void 0 : o.body), s = N(r);
  return i ? e.concat(s, s.visualViewport || [], ve(r) ? r : [], s.frameElement && n ? be(s.frameElement) : []) : e.concat(r, be(r, [], n));
}
function tn(t) {
  const e = V(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const r = j(t), i = r ? t.offsetWidth : n, s = r ? t.offsetHeight : o, a = Le(n) !== i || Le(o) !== s;
  return a && (n = i, o = s), {
    width: n,
    height: o,
    $: a
  };
}
function st(t) {
  return B(t) ? t : t.contextElement;
}
function ie(t) {
  const e = st(t);
  if (!j(e))
    return J(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: r,
    $: i
  } = tn(e);
  let s = (i ? Le(n.width) : n.width) / o, a = (i ? Le(n.height) : n.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const oo = /* @__PURE__ */ J(0);
function nn(t) {
  const e = N(t);
  return !it() || !e.visualViewport ? oo : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function ro(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== N(t) ? !1 : e;
}
function oe(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), i = st(t);
  let s = J(1);
  e && (o ? B(o) && (s = ie(o)) : s = ie(t));
  const a = ro(i, n, o) ? nn(i) : J(0);
  let f = (r.left + a.x) / s.x, c = (r.top + a.y) / s.y, g = r.width / s.x, l = r.height / s.y;
  if (i) {
    const h = N(i), u = o && B(o) ? N(o) : o;
    let m = h, _ = m.frameElement;
    for (; _ && o && u !== m; ) {
      const b = ie(_), p = _.getBoundingClientRect(), y = V(_), v = p.left + (_.clientLeft + parseFloat(y.paddingLeft)) * b.x, w = p.top + (_.clientTop + parseFloat(y.paddingTop)) * b.y;
      f *= b.x, c *= b.y, g *= b.x, l *= b.y, f += v, c += w, m = N(_), _ = m.frameElement;
    }
  }
  return Ae({
    width: g,
    height: l,
    x: f,
    y: c
  });
}
function io(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: r
  } = t;
  const i = r === "fixed", s = Z(o), a = e ? De(e.floating) : !1;
  if (o === s || a && i)
    return n;
  let f = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = J(1);
  const g = J(0), l = j(o);
  if ((l || !l && !i) && ((ge(o) !== "body" || ve(s)) && (f = $e(o)), j(o))) {
    const h = oe(o);
    c = ie(o), g.x = h.x + o.clientLeft, g.y = h.y + o.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - f.scrollLeft * c.x + g.x,
    y: n.y * c.y - f.scrollTop * c.y + g.y
  };
}
function so(t) {
  return Array.from(t.getClientRects());
}
function on(t) {
  return oe(Z(t)).left + $e(t).scrollLeft;
}
function ao(t) {
  const e = Z(t), n = $e(t), o = t.ownerDocument.body, r = ee(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), i = ee(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + on(t);
  const a = -n.scrollTop;
  return V(o).direction === "rtl" && (s += ee(e.clientWidth, o.clientWidth) - r), {
    width: r,
    height: i,
    x: s,
    y: a
  };
}
function lo(t, e) {
  const n = N(t), o = Z(t), r = n.visualViewport;
  let i = o.clientWidth, s = o.clientHeight, a = 0, f = 0;
  if (r) {
    i = r.width, s = r.height;
    const c = it();
    (!c || c && e === "fixed") && (a = r.offsetLeft, f = r.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a,
    y: f
  };
}
function co(t, e) {
  const n = oe(t, !0, e === "fixed"), o = n.top + t.clientTop, r = n.left + t.clientLeft, i = j(t) ? ie(t) : J(1), s = t.clientWidth * i.x, a = t.clientHeight * i.y, f = r * i.x, c = o * i.y;
  return {
    width: s,
    height: a,
    x: f,
    y: c
  };
}
function wt(t, e, n) {
  let o;
  if (e === "viewport")
    o = lo(t, n);
  else if (e === "document")
    o = ao(Z(t));
  else if (B(e))
    o = co(e, n);
  else {
    const r = nn(t);
    o = {
      ...e,
      x: e.x - r.x,
      y: e.y - r.y
    };
  }
  return Ae(o);
}
function rn(t, e) {
  const n = X(t);
  return n === e || !B(n) || de(n) ? !1 : V(n).position === "fixed" || rn(n, e);
}
function fo(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = be(t, [], !1).filter((a) => B(a) && ge(a) !== "body"), r = null;
  const i = V(t).position === "fixed";
  let s = i ? X(t) : t;
  for (; B(s) && !de(s); ) {
    const a = V(s), f = rt(s);
    !f && a.position === "fixed" && (r = null), (i ? !f && !r : !f && a.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || ve(s) && !f && rn(t, s)) ? o = o.filter((g) => g !== s) : r = a, s = X(s);
  }
  return e.set(t, o), o;
}
function uo(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = t;
  const s = [...n === "clippingAncestors" ? De(e) ? [] : fo(e, this._c) : [].concat(n), o], a = s[0], f = s.reduce((c, g) => {
    const l = wt(e, g, r);
    return c.top = ee(l.top, c.top), c.right = ce(l.right, c.right), c.bottom = ce(l.bottom, c.bottom), c.left = ee(l.left, c.left), c;
  }, wt(e, a, r));
  return {
    width: f.right - f.left,
    height: f.bottom - f.top,
    x: f.left,
    y: f.top
  };
}
function go(t) {
  const {
    width: e,
    height: n
  } = tn(t);
  return {
    width: e,
    height: n
  };
}
function ho(t, e, n) {
  const o = j(e), r = Z(e), i = n === "fixed", s = oe(t, !0, i, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const f = J(0);
  if (o || !o && !i)
    if ((ge(e) !== "body" || ve(r)) && (a = $e(e)), o) {
      const l = oe(e, !0, i, e);
      f.x = l.x + e.clientLeft, f.y = l.y + e.clientTop;
    } else r && (f.x = on(r));
  const c = s.left + a.scrollLeft - f.x, g = s.top + a.scrollTop - f.y;
  return {
    x: c,
    y: g,
    width: s.width,
    height: s.height
  };
}
function Ne(t) {
  return V(t).position === "static";
}
function kt(t, e) {
  return !j(t) || V(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function sn(t, e) {
  const n = N(t);
  if (De(t))
    return n;
  if (!j(t)) {
    let r = X(t);
    for (; r && !de(r); ) {
      if (B(r) && !Ne(r))
        return r;
      r = X(r);
    }
    return n;
  }
  let o = kt(t, e);
  for (; o && to(o) && Ne(o); )
    o = kt(o, e);
  return o && de(o) && Ne(o) && !rt(o) ? n : o || no(t) || n;
}
const po = async function(t) {
  const e = this.getOffsetParent || sn, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: ho(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function mo(t) {
  return V(t).direction === "rtl";
}
const bo = {
  convertOffsetParentRelativeRectToViewportRelativeRect: io,
  getDocumentElement: Z,
  getClippingRect: uo,
  getOffsetParent: sn,
  getElementRects: po,
  getClientRects: so,
  getDimensions: go,
  getScale: ie,
  isElement: B,
  isRTL: mo
};
function _o(t, e) {
  let n = null, o;
  const r = Z(t);
  function i() {
    var a;
    clearTimeout(o), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, f) {
    a === void 0 && (a = !1), f === void 0 && (f = 1), i();
    const {
      left: c,
      top: g,
      width: l,
      height: h
    } = t.getBoundingClientRect();
    if (a || e(), !l || !h)
      return;
    const u = ke(g), m = ke(r.clientWidth - (c + l)), _ = ke(r.clientHeight - (g + h)), b = ke(c), y = {
      rootMargin: -u + "px " + -m + "px " + -_ + "px " + -b + "px",
      threshold: ee(0, ce(1, f)) || 1
    };
    let v = !0;
    function w(x) {
      const k = x[0].intersectionRatio;
      if (k !== f) {
        if (!v)
          return s();
        k ? s(!1, k) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      v = !1;
    }
    try {
      n = new IntersectionObserver(w, {
        ...y,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(w, y);
    }
    n.observe(t);
  }
  return s(!0), i;
}
function yo(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: f = !1
  } = o, c = st(t), g = r || i ? [...c ? be(c) : [], ...be(e)] : [];
  g.forEach((p) => {
    r && p.addEventListener("scroll", n, {
      passive: !0
    }), i && p.addEventListener("resize", n);
  });
  const l = c && a ? _o(c, n) : null;
  let h = -1, u = null;
  s && (u = new ResizeObserver((p) => {
    let [y] = p;
    y && y.target === c && u && (u.unobserve(e), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var v;
      (v = u) == null || v.observe(e);
    })), n();
  }), c && !f && u.observe(c), u.observe(e));
  let m, _ = f ? oe(t) : null;
  f && b();
  function b() {
    const p = oe(t);
    _ && (p.x !== _.x || p.y !== _.y || p.width !== _.width || p.height !== _.height) && n(), _ = p, m = requestAnimationFrame(b);
  }
  return n(), () => {
    var p;
    g.forEach((y) => {
      r && y.removeEventListener("scroll", n), i && y.removeEventListener("resize", n);
    }), l == null || l(), (p = u) == null || p.disconnect(), u = null, f && cancelAnimationFrame(m);
  };
}
const an = Qn, vo = eo, xo = Xn, Ct = Jn, wo = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: bo,
    ...n
  }, i = {
    ...r.platform,
    _c: o
  };
  return Yn(t, e, {
    ...r,
    platform: i
  });
}, ln = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const { element: o, padding: r } = typeof t == "function" ? t(n) : t;
      return o && e(o) ? o.current != null ? Ct({ element: o.current, padding: r }).fn(n) : {} : o ? Ct({ element: o, padding: r }).fn(n) : {};
    }
  };
};
function Te(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, o, r;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n != e.length) return !1;
      for (o = n; o-- !== 0; )
        if (!Te(t[o], e[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(t), n = r.length, n !== Object.keys(e).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(e, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const i = r[o];
      if (!(i === "_owner" && t.$$typeof) && !Te(t[i], e[i]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function cn(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function St(t, e) {
  const n = cn(t);
  return Math.round(e * n) / n;
}
function Ft(t) {
  const e = U(t);
  return Re(() => {
    e.current = t;
  }), e;
}
function fn(t = {}) {
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: { reference: i, floating: s } = {},
    transform: a = !0,
    whileElementsMounted: f,
    open: c
  } = t, [g, l] = A({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [h, u] = A(o);
  Te(h, o) || u(o);
  const [m, _] = A(null), [b, p] = A(null), y = P(
    (F) => {
      F != k.current && (k.current = F, _(F));
    },
    [_]
  ), v = P(
    (F) => {
      F !== S.current && (S.current = F, p(F));
    },
    [p]
  ), w = i || m, x = s || b, k = U(null), S = U(null), I = U(g), T = Ft(f), C = Ft(r), M = P(() => {
    if (!k.current || !S.current)
      return;
    const F = {
      placement: e,
      strategy: n,
      middleware: h
    };
    C.current && (F.platform = C.current), wo(k.current, S.current, F).then(
      (D) => {
        const $ = { ...D, isPositioned: !0 };
        H.current && !Te(I.current, $) && (I.current = $, l($));
      }
    );
  }, [h, e, n, C]);
  Re(() => {
    c === !1 && I.current.isPositioned && (I.current.isPositioned = !1, l((F) => ({ ...F, isPositioned: !1 })));
  }, [c]);
  const H = U(!1);
  Re(() => (H.current = !0, () => {
    H.current = !1;
  }), []), Re(() => {
    if (w && (k.current = w), x && (S.current = x), w && x)
      return T.current ? T.current(w, x, M) : M();
  }, [w, x, M, T]);
  const W = Q(
    () => ({
      reference: k,
      floating: S,
      setReference: y,
      setFloating: v
    }),
    [y, v]
  ), R = Q(
    () => ({ reference: w, floating: x }),
    [w, x]
  ), K = Q(() => {
    const F = {
      position: n,
      left: 0,
      top: 0
    };
    if (!R.floating)
      return F;
    const D = St(R.floating, g.x), $ = St(R.floating, g.y);
    return a ? {
      ...F,
      transform: `translate(${D}px, ${$}px)`,
      ...cn(R.floating) >= 1.5 && { willChange: "transform" }
    } : {
      position: n,
      left: D,
      top: $
    };
  }, [n, a, R.floating, g.x, g.y]);
  return Q(
    () => ({
      ...g,
      update: M,
      refs: W,
      elements: R,
      floatingStyles: K
    }),
    [g, M, W, R, K]
  );
}
const ko = "@keyframes scale{0%{transform:scale(.95)}to{transform:scale(1)}}@keyframes floatUp{0%{transform:translateY(15%)}to{transform:translateY(0)}}@keyframes floatDown{0%{transform:translateY(-15%)}to{transform:translateY(0)}}@keyframes fade{0%{opacity:0}to{opacity:1}}.dialog.modal{margin:auto;margin-top:4rem}.dialog.modal[open]{animation:scale .1s cubic-bezier(.22,1,.36,1),fade .1s cubic-bezier(.22,1,.36,1)}.dialog.modal[open]::backdrop{animation:fade .15s cubic-bezier(.22,1,.36,1)}.dialog.anchored{position:absolute;margin:0}.dialog.anchored[open]{animation:scale .1s cubic-bezier(.22,1,.36,1),fade .1s cubic-bezier(.22,1,.36,1)}.dialog.anchored.top-start{transform-origin:bottom left}.dialog.anchored.top-end{transform-origin:bottom right}.dialog.anchored.right-start{transform-origin:left top}.dialog.anchored.right-end{transform-origin:left bottom}.dialog.anchored.bottom-start{transform-origin:top left}.dialog.anchored.bottom-end{transform-origin:top right}.dialog.anchored.left-start{transform-origin:right top}.dialog.anchored.left-end{transform-origin:right bottom}.dialog.unanchored.unanchored-bottom-left[open],.dialog.unanchored.unanchored-bottom-right[open]{animation:floatUp .3s cubic-bezier(.22,1,.36,1),fade .3s cubic-bezier(.22,1,.36,1)}.dialog.unanchored.unanchored-top-left[open],.dialog.unanchored.unanchored-top-right[open]{animation:floatDown .3s cubic-bezier(.22,1,.36,1),fade .3s cubic-bezier(.22,1,.36,1)}.dialog .arrow{position:absolute;width:8px;height:8px;transform:rotate(45deg)}.dialog-header{display:flex;align-items:center;justify-content:space-between;gap:1px;border-bottom:1px solid var(--border-color);padding:3px 12px}.dialog-content{position:relative;padding:7px 12px}";
function Co(t) {
  t.stopPropagation();
}
function So(t) {
  let e = document.querySelector(`#${t}`);
  if (!e) {
    e = document.createElement("div"), e.attachShadow({ mode: "open" }), e.style.all = "initial", e.id = t, document.body.appendChild(e);
    for (const n of Wt)
      e.addEventListener(n, Co, { passive: !0 });
  }
  return e.shadowRoot;
}
function Rt(t) {
  return t === void 0 ? "1rem" : typeof t == "number" ? t + "px" : t;
}
function at(t) {
  var o, r;
  const e = Rt((o = t.offset) == null ? void 0 : o.y), n = Rt((r = t.offset) == null ? void 0 : r.x);
  switch (t.placement) {
    case "top-left":
      return {
        top: e,
        left: n
      };
    case "top-right":
      return {
        top: e,
        right: n
      };
    case "bottom-left":
      return {
        bottom: e,
        left: n
      };
    case "bottom-right":
      return {
        bottom: e,
        right: n
      };
    default:
      return console.error("[Reflag]", "Invalid placement", t.placement), at({ placement: "bottom-right" });
  }
}
function dn({
  onClose: t,
  onOpen: e,
  initialValue: n = !1
} = {}) {
  const [o, r] = A(n), i = P(() => {
    r(!0), e == null || e();
  }, [e]), s = P(() => {
    r(!1), t == null || t();
  }, [t]), a = P(() => {
    o ? t == null || t() : e == null || e(), r((f) => !f);
  }, [o, t, e]);
  return {
    isOpen: o,
    open: i,
    close: s,
    toggle: a
  };
}
const un = ({
  position: t,
  isOpen: e,
  close: n,
  onDismiss: o,
  containerId: r,
  strategy: i,
  children: s,
  showArrow: a = !0
}) => {
  const f = U(null), c = U(null), g = t.type === "POPOVER" ? t.anchor : null, l = t.type === "POPOVER" ? t.placement : void 0, {
    refs: h,
    floatingStyles: u,
    middlewareData: m,
    placement: _
  } = fn({
    elements: {
      reference: g
    },
    strategy: i,
    transform: !1,
    placement: l,
    whileElementsMounted: yo,
    middleware: [
      xo({
        padding: 10,
        mainAxis: !0,
        crossAxis: !0
      }),
      vo(),
      an(8),
      ln({
        element: f
      })
    ]
  });
  let b = {};
  t.type === "DIALOG" && (b = at(t));
  const p = P(() => {
    n(), o == null || o();
  }, [n, o]);
  le(() => {
    if (t.type === "MODAL" || t.type === "DIALOG") return;
    const w = (S) => {
      S.key == "Escape" && p();
    }, x = (S) => {
      (!(S.target instanceof Element) || !S.target.closest(`#${r}`)) && p();
    }, k = new MutationObserver((S) => {
      t.anchor !== null && S.forEach((I) => {
        Array.from(I.removedNodes).some((M) => M === t.anchor || M.contains(t.anchor)) && n();
      });
    });
    return window.addEventListener("mousedown", x), window.addEventListener("keydown", w), k.observe(document.body, {
      subtree: !0,
      childList: !0
    }), () => {
      window.removeEventListener("mousedown", x), window.removeEventListener("keydown", w), k.disconnect();
    };
  }, [t.type, n, t.anchor, p, r]);
  function y(w) {
    h.setFloating(w), c.current = w;
  }
  le(() => {
    c.current && (e && !c.current.hasAttribute("open") && c.current[t.type === "MODAL" ? "showModal" : "show"](), !e && c.current.hasAttribute("open") && c.current.close());
  }, [c, e, t.type]);
  const v = [
    "dialog",
    t.type === "MODAL" ? "modal" : t.type === "POPOVER" ? "anchored" : `unanchored unanchored-${t.placement}`,
    _
  ].join(" ");
  return /* @__PURE__ */ d(z, null, /* @__PURE__ */ d("style", { dangerouslySetInnerHTML: { __html: ko } }), /* @__PURE__ */ d(
    "dialog",
    {
      ref: y,
      class: v,
      style: g ? u : b
    },
    s && /* @__PURE__ */ d(z, null, s),
    g && a && /* @__PURE__ */ d(
      Fo,
      {
        arrowData: m == null ? void 0 : m.arrow,
        arrowRef: f,
        placement: _
      }
    )
  ));
};
function Fo({
  arrowData: t,
  arrowRef: e,
  placement: n
}) {
  const { x: o, y: r } = t ?? {}, i = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  }[n.split("-")[0]] || "bottom", s = {
    left: o != null ? `${o}px` : "",
    top: r != null ? `${r}px` : "",
    right: "",
    bottom: "",
    [i]: "-4px"
  };
  return /* @__PURE__ */ d(
    "div",
    {
      ref: e,
      class: ["arrow", n].join(" "),
      style: s
    }
  );
}
function Ro({
  children: t,
  innerRef: e
}) {
  return /* @__PURE__ */ d("header", { ref: e, class: "dialog-header" }, t);
}
function Eo({
  children: t,
  innerRef: e
}) {
  return /* @__PURE__ */ d("div", { ref: e, class: "dialog-content" }, t);
}
const Io = (t) => /* @__PURE__ */ d(
  "svg",
  {
    fill: "none",
    height: "22",
    viewBox: "0 0 24 24",
    width: "22",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ d(
    "path",
    {
      d: "M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z",
      fill: "currentColor"
    }
  )
), He = {
  DefaultQuestionLabel: "How satisfied are you with this feature?",
  QuestionPlaceholder: "Write a comment",
  ScoreStatusDescription: "Pick a score and leave a comment",
  ScoreStatusLoading: "Saving score, please wait...",
  ScoreStatusReceived: "Score has been received!",
  ScoreVeryDissatisfiedLabel: "Very dissatisfied (1/5)",
  ScoreDissatisfiedLabel: "Dissatisfied (2/5)",
  ScoreNeutralLabel: "Neutral (3/5)",
  ScoreSatisfiedLabel: "Satisfied (4/5)",
  ScoreVerySatisfiedLabel: "Very satisfied (5/5)",
  SuccessMessage: "Feedback received, thank you!",
  SendButton: "Send feedback"
}, Lo = ({
  initialDuration: t,
  enabled: e,
  onEnd: n
}) => {
  const [o, r] = A(!e), [i, s] = A(t), [a, f] = A(Date.now()), [c, g] = A(Date.now());
  le(() => {
    if (o) return;
    const b = setInterval(() => {
      g(Date.now()), Date.now() >= a + i && (clearTimeout(b), r(!0), n());
    }, 25);
    return () => {
      clearTimeout(b);
    };
  }, [i, n, a, o]);
  const l = P(() => {
    r(!0);
  }, []), h = P((b) => {
    f(Date.now()), s(b), r(!1);
  }, []), u = a + i, _ = (o ? 0 : c - a) / i;
  return {
    duration: i,
    elapsedFraction: _,
    startTime: a,
    endTime: u,
    stopped: o,
    startWithDuration: h,
    stop: l
  };
}, Oo = (t) => /* @__PURE__ */ d(
  "svg",
  {
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ d(
    "path",
    {
      d: "m10 15.17l9.193-9.191l1.414 1.414l-10.606 10.606l-6.364-6.364l1.414-1.414l4.95 4.95Z",
      fill: "currentColor"
    }
  )
), Ao = (t) => /* @__PURE__ */ d(
  "svg",
  {
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ d(
    "path",
    {
      d: "M12 24C5.3724 24 0 18.6276 0 12C0 5.3724 5.3724 0 12 0C18.6276 0 24 5.3724 24 12C24 18.6276 18.6276 24 12 24ZM10.8036 16.8L19.2876 8.3148L17.5908 6.618L10.8036 13.4064L7.4088 10.0116L5.712 11.7084L10.8036 16.8Z",
      fill: "currentColor"
    }
  )
), To = ({
  variant: t = "primary",
  children: e,
  ...n
}) => {
  const o = ["button", t].join(" ");
  return /* @__PURE__ */ d("button", { class: o, ...n }, e);
}, gn = (t = { height: "10px", width: "10px" }) => /* @__PURE__ */ d(
  "svg",
  {
    width: "128",
    height: "128",
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ d(
    "path",
    {
      d: "M117.333 0C123.224 0 128 4.77563 128 10.6667V117.333C128 123.224 123.224 128 117.333 128H10.6667C4.77563 128 1.71804e-07 123.224 0 117.333V10.6667C0 4.77563 4.77563 1.71801e-07 10.6667 0H117.333ZM10.6667 10.6667V117.333L117.333 10.6667H10.6667Z",
      fill: "currentColor"
    }
  )
), Et = () => /* @__PURE__ */ d("footer", { class: "plug" }, /* @__PURE__ */ d("a", { href: "https://reflag.com", rel: "noreferrer", target: "_blank" }, "Powered by ", /* @__PURE__ */ d(gn, { height: "10px", width: "10px" }), " Reflag")), Mo = (t) => /* @__PURE__ */ d(
  "svg",
  {
    fill: "none",
    height: "22",
    viewBox: "0 0 24 24",
    width: "22",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ d(
    "path",
    {
      d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M12 15C13.1835 15 14.2712 15.4113 15.1279 16.0991C15.4665 16.3709 15.4398 16.8738 15.1187 17.166C14.8962 17.3685 14.5788 17.4225 14.2915 17.3332C13.605 17.1198 12.8259 17 12 17C11.1741 17 10.3949 17.1205 9.70841 17.3331C9.42116 17.422 9.104 17.3677 8.88161 17.1653C8.56025 16.8728 8.53318 16.3695 8.87206 16.0976C9.2087 15.8274 9.57986 15.6014 9.97666 15.426C10.6139 15.1442 11.3032 14.9991 12 15ZM8.5 10C8.89783 10 9.27936 10.158 9.56066 10.4393C9.84197 10.7206 10 11.1022 10 11.5C10 11.8978 9.84197 12.2794 9.56066 12.5607C9.27936 12.842 8.89783 13 8.5 13C8.10218 13 7.72065 12.842 7.43934 12.5607C7.15804 12.2794 7 11.8978 7 11.5C7 11.1022 7.15804 10.7206 7.43934 10.4393C7.72065 10.158 8.10218 10 8.5 10ZM15.5 10C15.8978 10 16.2794 10.158 16.5607 10.4393C16.842 10.7206 17 11.1022 17 11.5C17 11.8978 16.842 12.2794 16.5607 12.5607C16.2794 12.842 15.8978 13 15.5 13C15.1022 13 14.7206 12.842 14.4393 12.5607C14.158 12.2794 14 11.8978 14 11.5C14 11.1022 14.158 10.7206 14.4393 10.4393C14.7206 10.158 15.1022 10 15.5 10Z",
      fill: "currentColor"
    }
  )
), Po = (t) => /* @__PURE__ */ d(
  "svg",
  {
    fill: "none",
    height: "22",
    viewBox: "0 0 24 24",
    width: "22",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ d(
    "path",
    {
      d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM8 15C8 14.4477 8.44771 14 9 14H15C15.5523 14 16 14.4477 16 15V15C16 15.5523 15.5523 16 15 16H9C8.44771 16 8 15.5523 8 15V15ZM8 11C7.60217 11 7.22064 10.842 6.93934 10.5607C6.65803 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10217 6.65803 8.72064 6.93934 8.43934C7.22064 8.15803 7.60217 8 8 8C8.39782 8 8.77935 8.15803 9.06066 8.43934C9.34196 8.72064 9.5 9.10217 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77935 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10217 14.658 8.72064 14.9393 8.43934C15.2206 8.15803 15.6022 8 16 8C16.3978 8 16.7794 8.15803 17.0607 8.43934C17.342 8.72064 17.5 9.10217 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z",
      fill: "currentColor"
    }
  )
), Do = (t) => /* @__PURE__ */ d(
  "svg",
  {
    fill: "none",
    height: "22",
    viewBox: "0 0 24 24",
    width: "22",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ d(
    "path",
    {
      d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM8 11C7.60217 11 7.22064 10.842 6.93934 10.5607C6.65803 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10217 6.65803 8.72064 6.93934 8.43934C7.22064 8.15803 7.60217 8 8 8C8.39782 8 8.77935 8.15803 9.06066 8.43934C9.34196 8.72064 9.5 9.10217 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77935 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10217 14.658 8.72064 14.9393 8.43934C15.2206 8.15803 15.6022 8 16 8C16.3978 8 16.7794 8.15803 17.0607 8.43934C17.342 8.72064 17.5 9.10217 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M7.79862 15.4322C8.85269 16.5065 10.4964 17.4971 11.9993 17.4971C13.5011 17.4971 15.1701 16.5079 16.2097 15.4351C16.5083 15.1269 16.4581 14.6416 16.1408 14.3528C15.9042 14.1375 15.5656 14.0777 15.2972 14.2517C14.5161 14.7578 13.4271 15.7002 11.9993 15.7002C10.5688 15.7002 9.47831 14.7549 8.69694 14.2486C8.43116 14.0764 8.09564 14.1353 7.86141 14.3485C7.5435 14.6378 7.49757 15.1254 7.79862 15.4322Z",
      fill: "currentColor"
    }
  )
), $o = (t) => /* @__PURE__ */ d(
  "svg",
  {
    fill: "none",
    height: "22",
    viewBox: "0 0 24 24",
    width: "22",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ d(
    "path",
    {
      d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM8 17C7.44771 17 6.98992 16.5479 7.09965 16.0066C7.29346 15.0506 7.76447 14.1645 8.46447 13.4645C9.40215 12.5268 10.6739 12 12 12C13.3261 12 14.5979 12.5268 15.5355 13.4645C16.2355 14.1645 16.7065 15.0506 16.9003 16.0066C17.0101 16.5479 16.5523 17 16 17V17C15.4477 17 15.0156 16.5403 14.8349 16.0184C14.6877 15.5934 14.4454 15.2028 14.1213 14.8787C13.5587 14.3161 12.7956 14 12 14C11.2043 14 10.4413 14.3161 9.87868 14.8787C9.55459 15.2028 9.31232 15.5934 9.16513 16.0184C8.98442 16.5403 8.55228 17 8 17V17ZM8 11C7.60217 11 7.22064 10.842 6.93934 10.5607C6.65803 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10217 6.65803 8.72064 6.93934 8.43934C7.22064 8.15803 7.60217 8 8 8C8.39782 8 8.77935 8.15803 9.06066 8.43934C9.34196 8.72064 9.5 9.10217 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77935 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10217 14.658 8.72064 14.9393 8.43934C15.2206 8.15803 15.6022 8 16 8C16.3978 8 16.7794 8.15803 17.0607 8.43934C17.342 8.72064 17.5 9.10217 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z",
      fill: "currentColor"
    }
  )
), Uo = (t) => /* @__PURE__ */ d(
  "svg",
  {
    fill: "none",
    height: "22",
    viewBox: "0 0 24 24",
    width: "22",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ d(
    "path",
    {
      d: "M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM12 12C14 12 15.667 12.333 17 13C17 14.3261 16.4732 15.5979 15.5355 16.5355C14.5979 17.4732 13.3261 18 12 18C10.6739 18 9.40215 17.4732 8.46447 16.5355C7.52678 15.5979 7 14.3261 7 13C8.333 12.333 10 12 12 12ZM8.5 7C9.07633 6.99988 9.63499 7.19889 10.0815 7.56335C10.5279 7.9278 10.8347 8.43532 10.95 9H6.05C6.16526 8.43532 6.47209 7.9278 6.91855 7.56335C7.36501 7.19889 7.92367 6.99988 8.5 7ZM15.5 7C16.0763 6.99988 16.635 7.19889 17.0814 7.56335C17.5279 7.9278 17.8347 8.43532 17.95 9H13.05C13.1653 8.43532 13.4721 7.9278 13.9185 7.56335C14.365 7.19889 14.9237 6.99988 15.5 7Z",
      fill: "currentColor"
    }
  )
), It = [
  {
    color: "var(--reflag-feedback-dialog-rating-1-color, #dd6b20)",
    bg: "var(--reflag-feedback-dialog-rating-1-background-color, #fbd38d)",
    icon: /* @__PURE__ */ d($o, null),
    getLabel: (t) => t.ScoreVeryDissatisfiedLabel,
    value: 1
  },
  {
    color: "var(--reflag-feedback-dialog-rating-2-color, #ed8936)",
    bg: "var(--reflag-feedback-dialog-rating-2-background-color, #feebc8)",
    icon: /* @__PURE__ */ d(Mo, null),
    getLabel: (t) => t.ScoreDissatisfiedLabel,
    value: 2
  },
  {
    color: "var(--reflag-feedback-dialog-rating-3-color, #787c91)",
    bg: "var(--reflag-feedback-dialog-rating-3-background-color, #e9e9ed)",
    icon: /* @__PURE__ */ d(Po, null),
    getLabel: (t) => t.ScoreNeutralLabel,
    value: 3
  },
  {
    color: "var(--reflag-feedback-dialog-rating-4-color, #48bb78)",
    bg: "var(--reflag-feedback-dialog-rating-4-background-color, #c6f6d5)",
    icon: /* @__PURE__ */ d(Do, null),
    getLabel: (t) => t.ScoreSatisfiedLabel,
    value: 4
  },
  {
    color: "var(--reflag-feedback-dialog-rating-5-color, #38a169)",
    bg: "var(--reflag-feedback-dialog-rating-5-background-color, #9ae6b4)",
    icon: /* @__PURE__ */ d(Uo, null),
    getLabel: (t) => t.ScoreVerySatisfiedLabel,
    value: 5
  }
], No = ({
  t,
  name: e,
  selectedValue: n,
  onChange: o
}) => /* @__PURE__ */ d("div", { class: "star-rating" }, /* @__PURE__ */ d("style", null, It.map(
  ({ bg: r, color: i }, s) => `
            .star-rating-icons > input:nth-of-type(${s + 1}):checked + .button {
              border-color: ${i};
            }

            .star-rating-icons > input:nth-of-type(${s + 1}):checked + .button > div {
              background-color: ${r};
            }

            .star-rating-icons > input:nth-of-type(${s + 1}):checked ~ input:nth-of-type(${s + 2}) + .button {
              border-left-color: ${i};
            }
          `
)), /* @__PURE__ */ d("div", { class: "star-rating-icons" }, It.map((r) => /* @__PURE__ */ d(
  Ho,
  {
    key: r.value,
    isSelected: r.value === n,
    name: e,
    score: r,
    t,
    onChange: o
  }
)))), Ho = ({
  isSelected: t,
  name: e,
  onChange: n,
  score: o,
  t: r
}) => {
  var c, g;
  const i = U(null), { refs: s, floatingStyles: a, middlewareData: f } = fn({
    placement: "top",
    middleware: [
      an(4),
      ln({
        element: i
      })
    ]
  });
  return /* @__PURE__ */ d(z, null, /* @__PURE__ */ d(
    "input",
    {
      defaultChecked: t,
      id: `reflag-feedback-score-${o.value}`,
      name: e,
      type: "radio",
      value: o.value,
      onChange: n
    }
  ), /* @__PURE__ */ d(
    "label",
    {
      ref: s.setReference,
      "aria-label": o.getLabel(r),
      class: "button",
      for: `reflag-feedback-score-${o.value}`,
      style: { color: o.color }
    },
    /* @__PURE__ */ d(
      "div",
      {
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          opacity: 0.2,
          // TODO: fix overflow
          zIndex: 1
        }
      }
    ),
    /* @__PURE__ */ d("span", { style: { zIndex: 2, display: "flex", alignItems: "center" } }, o.icon)
  ), /* @__PURE__ */ d("div", { ref: s.setFloating, class: "button-tooltip", style: a }, o.getLabel(r), /* @__PURE__ */ d(
    "div",
    {
      ref: i,
      class: "button-tooltip-arrow",
      style: {
        left: ((c = f.arrow) == null ? void 0 : c.x) != null ? `${f.arrow.x}px` : "",
        top: ((g = f.arrow) == null ? void 0 : g.y) != null ? `${f.arrow.y}px` : ""
      }
    }
  )));
}, zo = 400;
function Bo(t) {
  var n, o;
  const e = new FormData(t);
  return {
    score: Number((n = e.get("score")) == null ? void 0 : n.toString()),
    comment: (((o = e.get("comment")) == null ? void 0 : o.toString()) || "").trim()
  };
}
const Vo = ({
  question: t,
  scoreState: e,
  openWithCommentVisible: n,
  onInteraction: o,
  onSubmit: r,
  onScoreSubmit: i,
  t: s
}) => {
  const [a, f] = A(!1), [c, g] = A(
    "idle"
  ), [l, h] = A(), [u, m] = A(!0), _ = async (I) => {
    I.preventDefault();
    const T = {
      ...Bo(I.target),
      question: t
    };
    if (T.score) {
      h("");
      try {
        g("submitting"), await r(T), g("submitted");
      } catch (C) {
        g("idle"), C instanceof Error ? h(C.message) : h(typeof C == "string" ? C : "Couldn't submit feedback. Please try again.");
      }
    }
  }, b = U(null), p = U(null), y = U(null), v = U(null), w = U(null), x = P(() => {
    b.current !== null && y.current !== null && v.current !== null && (b.current.style.maxHeight = `${y.current.clientHeight}px`, v.current.style.position = "absolute", v.current.style.opacity = "0", v.current.style.pointerEvents = "none");
  }, [b, y, v]), k = P(() => {
    b.current !== null && y.current !== null && v.current !== null && (b.current.style.maxHeight = `${y.current.clientHeight + // Header height
    v.current.clientHeight + // Comment + Button Height
    10}px`, v.current.style.position = "relative", v.current.style.opacity = "1", v.current.style.pointerEvents = "all");
  }, [b, y, v]), S = P(() => {
    b.current !== null && p.current !== null && w.current !== null && (p.current.style.opacity = "0", p.current.style.pointerEvents = "none", b.current.style.maxHeight = `${w.current.clientHeight}px`, setTimeout(() => {
      w.current.style.position = "relative", w.current.style.opacity = "1", w.current.style.pointerEvents = "all", m(!1);
    }, zo + 10));
  }, [p, b, w]);
  return le(() => {
    c === "submitted" ? S() : n || a ? k() : x();
  }, [
    x,
    k,
    S,
    n,
    a,
    c
  ]), /* @__PURE__ */ d("div", { ref: b, class: "container" }, /* @__PURE__ */ d("div", { ref: w, class: "submitted" }, /* @__PURE__ */ d("div", { class: "submitted-check" }, /* @__PURE__ */ d(Ao, { height: 24, width: 24 })), /* @__PURE__ */ d("p", { class: "text" }, s.SuccessMessage), /* @__PURE__ */ d(Et, null)), u && /* @__PURE__ */ d(
    "form",
    {
      ref: p,
      class: "form",
      method: "dialog",
      style: { opacity: 1 },
      onClick: o,
      onFocus: o,
      onFocusCapture: o,
      onSubmit: _
    },
    /* @__PURE__ */ d(
      "div",
      {
        ref: y,
        "aria-labelledby": "reflag-feedback-score-label",
        class: "form-control",
        role: "group"
      },
      /* @__PURE__ */ d("div", { class: "title", id: "reflag-feedback-score-label" }, t),
      /* @__PURE__ */ d(
        No,
        {
          name: "score",
          t: s,
          onChange: async (I) => {
            f(!0), await i({
              question: t,
              score: Number(I.currentTarget.value)
            });
          }
        }
      ),
      /* @__PURE__ */ d(jo, { scoreState: e, t: s })
    ),
    /* @__PURE__ */ d("div", { ref: v, class: "form-expanded-content" }, /* @__PURE__ */ d("div", { class: "form-control" }, /* @__PURE__ */ d(
      "textarea",
      {
        class: "textarea",
        id: "reflag-feedback-comment-label",
        name: "comment",
        placeholder: s.QuestionPlaceholder,
        rows: 4
      }
    )), l && /* @__PURE__ */ d("p", { class: "error" }, l), /* @__PURE__ */ d(
      To,
      {
        disabled: !a || c === "submitting" || e === "submitting",
        type: "submit"
      },
      s.SendButton
    ), /* @__PURE__ */ d(Et, null))
  ));
}, jo = ({ t, scoreState: e }) => {
  const [n, o] = A(!1), [r, i] = A(!1);
  le(() => {
    if (e === "idle") {
      o(!1);
      return;
    }
    if (e === "submitted") {
      o(!1), i(!0);
      return;
    }
    const c = setTimeout(() => {
      o(!0);
    }, 400);
    return () => clearTimeout(c);
  }, [e]);
  const s = e === "idle" || e === "submitting" && !r && !n, a = e !== "submitted" && !r && n, f = e === "submitted" || r;
  return /* @__PURE__ */ d("div", { class: "score-status-container" }, /* @__PURE__ */ d("span", { class: "score-status", style: { opacity: s ? 1 : 0 } }, t.ScoreStatusDescription), /* @__PURE__ */ d("div", { class: "score-status", style: { opacity: a ? 1 : 0 } }, t.ScoreStatusLoading), /* @__PURE__ */ d("span", { class: "score-status", style: { opacity: f ? 1 : 0 } }, /* @__PURE__ */ d(Oo, { height: 14, style: { marginRight: 3 }, width: 14 }), " ", t.ScoreStatusReceived));
}, Ko = ".button{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:inline-flex;align-items:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;position:relative;white-space:nowrap;height:2rem;padding-left:.75rem;padding-right:.75rem;gap:.5em;justify-content:center;border:none;cursor:pointer;font-family:var(--reflag-feedback-dialog-font-family);font-size:12px;font-weight:500;box-shadow:0 1px 2px #0000000f,0 1px 1px #00000003;border-radius:6px;border-radius:var(--reflag-feedback-dialog-border-radius, 6px);transition-duration:.2s;transition-property:background-color,border-color,color,opacity,box-shadow,transform}.button.primary{background-color:#fff;background-color:var( --reflag-feedback-dialog-primary-button-background-color, white );color:#1e1f24;color:var(--reflag-feedback-dialog-primary-button-color, #1e1f24);border:1px solid #d8d9df;border:1px solid var(--reflag-feedback-dialog-primary-border-color, #d8d9df)}.button:disabled{opacity:.5;cursor:not-allowed;border-color:#d8d9df;border-color:var(--reflag-feedback-dialog-primary-border-color, #d8d9df);transition-duration:.2s;transition-property:background-color,border-color,color,opacity,box-shadow,transform}.button:focus{outline:none;border-color:#787c91;border-color:var( --reflag-feedback-dialog-input-focus-border-color, #787c91 )}.dialog{position:fixed;width:210px;padding:16px 22px 10px;font-size:1rem;font-size:var(--reflag-feedback-dialog-font-size, 1rem);font-family:InterVariable,Inter,system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,Open Sans,sans-serif;font-family:var( --reflag-feedback-dialog-font-family, InterVariable, Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, Open Sans, sans-serif );color:#1e1f24;color:var(--reflag-feedback-dialog-color, #1e1f24);border:1px solid;border-color:#d8d9df;border-color:var(--reflag-feedback-dialog-border, #d8d9df);border-radius:6px;border-radius:var(--reflag-feedback-dialog-border-radius, 6px);box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d;box-shadow:var( --reflag-feedback-dialog-box-shadow, 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -2px rgba(0, 0, 0, .05) );background-color:#fff;background-color:var(--reflag-feedback-dialog-background-color, #fff);z-index:2147410000}.dialog:not(.modal){margin:0;margin:initial;top:auto;top:initial;right:auto;right:initial;left:auto;left:initial;bottom:auto;bottom:initial}.arrow{background-color:#fff;background-color:var(--reflag-feedback-dialog-background-color, #fff);box-shadow:#d8d9df -1px -1px 1px;box-shadow:var(--reflag-feedback-dialog-border, #d8d9df) -1px -1px 1px 0}.arrow.bottom{box-shadow:#d8d9df -1px -1px 1px;box-shadow:var(--reflag-feedback-dialog-border, #d8d9df) -1px -1px 1px 0}.arrow.top{box-shadow:#d8d9df 1px 1px 1px;box-shadow:var(--reflag-feedback-dialog-border, #d8d9df) 1px 1px 1px 0}.arrow.left{box-shadow:#d8d9df 1px -1px 1px;box-shadow:var(--reflag-feedback-dialog-border, #d8d9df) 1px -1px 1px 0}.arrow.right{box-shadow:#d8d9df -1px 1px 1px;box-shadow:var(--reflag-feedback-dialog-border, #d8d9df) -1px 1px 1px 0}.close{position:absolute;top:6px;right:6px;width:28px;height:28px;padding:0;margin:0;background:none;border:none;cursor:pointer;display:flex;justify-content:center;align-items:center;color:#1e1f24;color:var(--reflag-feedback-dialog-color, #1e1f24)}.close svg{position:absolute}.plug{font-size:.75em;text-align:center;margin-top:7px;width:100%}.plug a{opacity:.5;color:#1e1f24;color:var(--reflag-feedback-dialog-color, #1e1f24);-webkit-text-decoration:none;text-decoration:none;transition:opacity .2s}.plug a:hover{opacity:.7}.container{overflow-y:hidden;transition:max-height .4s cubic-bezier(.65,0,.35,1)}.form{display:flex;flex-direction:column;align-items:flex-start;gap:10px;overflow-y:hidden;max-height:400px;transition:opacity .4s cubic-bezier(.65,0,.35,1)}.form-control{display:flex;flex-direction:column;width:100%;gap:8px;border:none;padding:0;margin:0;font-size:12px;color:#787c91;color:var(--reflag-feedback-dialog-secondary-color, #787c91)}.form-expanded-content{width:100%;display:flex;flex-direction:column;align-items:flex-start;gap:10px;transition:opacity .4s cubic-bezier(.65,0,.35,1);opacity:0;position:absolute;top:0;left:0}.title{color:#1e1f24;color:var(--reflag-feedback-dialog-color, #1e1f24);font-size:15px;font-weight:400;line-height:115%;text-wrap:balance;max-width:calc(100% - 20px);margin-bottom:6px;line-height:1.3}.dimmed{opacity:.5}.textarea{background-color:transparent;border:1px solid;border-color:#d8d9df;border-color:var(--reflag-feedback-dialog-input-border-color, #d8d9df);padding:.5rem .75rem;border-radius:6px;border-radius:var(--reflag-feedback-dialog-border-radius, 6px);transition:border-color .2s ease-in-out;font-family:InterVariable,Inter,system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,Open Sans,sans-serif;font-family:var( --reflag-feedback-dialog-font-family, InterVariable, Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, Open Sans, sans-serif );line-height:1.3;resize:none;color:#1e1f24;color:var(--reflag-feedback-dialog-color, #1e1f24);font-size:13px}.textarea::-moz-placeholder{color:#1e1f24;color:var(--reflag-feedback-dialog-color, #1e1f24);opacity:.36}.textarea::placeholder{color:#1e1f24;color:var(--reflag-feedback-dialog-color, #1e1f24);opacity:.36}.textarea:focus{outline:none;border-color:#787c91;border-color:var( --reflag-feedback-dialog-input-focus-border-color, #787c91 )}.score-status-container{position:relative;padding-bottom:6px;height:14px}.score-status-container>.score-status{display:flex;align-items:center;position:absolute;top:0;left:0;opacity:0;transition:opacity .2s ease-in-out}.error{margin:0;color:#e53e3e;color:var(--reflag-feedback-dialog-error-color, #e53e3e);font-size:.8125em;font-weight:500}.submitted{display:flex;flex-direction:column;transition:opacity .4s cubic-bezier(.65,0,.35,1);position:absolute;top:0;left:0;opacity:0;pointer-events:none;width:calc(100% - 56px);padding:0 28px}.submitted .submitted-check{background:#fff;background:var(--reflag-feedback-dialog-submitted-check-color, #fff);color:#38a169;color:var( --reflag-feedback-dialog-submitted-check-background-color, #38a169 );height:24px;width:24px;display:block;border-radius:50%;flex-shrink:0;display:flex;align-items:center;justify-content:center;margin:16px auto 8px}.submitted .text{margin:auto auto 16px;text-align:center;color:#1e1f24;color:var(--reflag-feedback-dialog-color, #1e1f24);font-size:1rem;font-size:var(--reflag-feedback-dialog-font-size, 1rem);font-weight:400;line-height:130%;flex-grow:1;max-width:160px}.submitted>.plug{flex-grow:0}.radial-progress>circle{stroke:#1e1f24;stroke:var(--reflag-feedback-dialog-color, #1e1f24);opacity:.2}.star-rating{display:flex;flex-direction:column}.star-rating-icons{display:flex;width:0}.star-rating-icons>input{border:0px;clip:rect(0px,0px,0px,0px);height:1px;width:1px;margin:-1px;padding:0;overflow:hidden;white-space:nowrap;position:absolute}.star-rating-icons>.button{border:1px solid;border-color:#d8d9df;border-color:var(--reflag-feedback-dialog-input-border-color, #d8d9df);padding:0 7px}.star-rating-icons>.button:not(:first-of-type){border-top-left-radius:0;border-bottom-left-radius:0}.star-rating-icons>.button:not(:last-of-type){border-top-right-radius:0;border-bottom-right-radius:0;margin-right:-1px}.star-rating-icons>.button+.button-tooltip{pointer-events:none;opacity:0;background:#000;background:var(--reflag-feedback-dialog-tooltip-background-color, #000);color:#fff;color:var(--reflag-feedback-dialog-tooltip-color, #fff);padding:6px 8px;border-radius:4px;font-size:13px}.star-rating-icons>.button:hover+.button-tooltip{opacity:1}.star-rating-icons>.button>svg{transition:transform .2s ease-in-out}.button-tooltip-arrow{position:absolute;width:10px;height:10px;background-color:#000;background-color:var( --reflag-feedback-dialog-tooltip-background-color, #000 );transform:rotate(45deg)}", Zo = ({ diameter: t, progress: e }) => {
  const o = t / 2 - 2, r = 2 * Math.PI * o, i = r * e;
  return /* @__PURE__ */ d("svg", { class: "radial-progress", height: t, width: t }, /* @__PURE__ */ d(
    "circle",
    {
      cx: o + 2,
      cy: o + 2,
      fill: "transparent",
      r: o,
      "stroke-dasharray": r,
      "stroke-dashoffset": i,
      "stroke-width": 2,
      transform: `rotate(-90) translate(-${o * 2 + 2 * 2} 0)`
    }
  ));
}, Wo = 20 * 1e3, qo = 3 * 1e3, Yo = ({
  key: t,
  title: e = He.DefaultQuestionLabel,
  position: n,
  translations: o = He,
  openWithCommentVisible: r = !1,
  onClose: i,
  onDismiss: s,
  onSubmit: a,
  onScoreSubmit: f
}) => {
  const [c, g] = A(void 0), [l, h] = A("idle"), { isOpen: u, close: m } = dn({ onClose: i, initialValue: !0 }), _ = Lo({
    enabled: n.type === "DIALOG",
    initialDuration: Wo,
    onEnd: m
  }), b = P(
    async (v) => {
      await a({ ...v, feedbackId: c }), _.startWithDuration(qo);
    },
    [_, c, a]
  ), p = P(
    async (v) => {
      if (f !== void 0) {
        h("submitting");
        const w = await f({ ...v, feedbackId: c });
        g(w.feedbackId), h("submitted");
      }
    },
    [c, f]
  ), y = P(() => {
    _.stop(), m(), s == null || s();
  }, [_, m, s]);
  return /* @__PURE__ */ d(z, null, /* @__PURE__ */ d("style", { dangerouslySetInnerHTML: { __html: Ko } }), /* @__PURE__ */ d(
    un,
    {
      key: t,
      close: m,
      containerId: Ze,
      isOpen: u,
      position: n,
      onDismiss: s
    },
    /* @__PURE__ */ d(z, null, /* @__PURE__ */ d(
      Vo,
      {
        key: t,
        openWithCommentVisible: r,
        question: e,
        scoreState: l,
        t: { ...He, ...o },
        onInteraction: _.stop,
        onScoreSubmit: p,
        onSubmit: b
      }
    ), /* @__PURE__ */ d("button", { class: "close", onClick: y }, !_.stopped && _.elapsedFraction > 0 && /* @__PURE__ */ d(
      Zo,
      {
        diameter: 28,
        progress: 1 - _.elapsedFraction
      }
    ), /* @__PURE__ */ d(Io, null)))
  ));
}, hn = {
  type: "DIALOG",
  placement: "bottom-right"
};
function Jo(t) {
  t.stopPropagation();
}
function Xo() {
  let t = document.querySelector(`#${Ze}`);
  if (!t) {
    t = document.createElement("div"), t.attachShadow({ mode: "open" }), t.style.all = "initial", t.id = Ze, document.body.appendChild(t);
    for (const e of Wt)
      t.addEventListener(e, Jo, { passive: !0 });
  }
  return t.shadowRoot;
}
let Lt = 0;
function pn(t) {
  const e = Xo(), n = t.position || hn;
  if (n.type === "POPOVER") {
    if (!n.anchor) {
      console.warn(
        "[Reflag]",
        "Unable to open popover. Anchor must be a defined DOM-element"
      );
      return;
    }
    if (!document.body.contains(n.anchor)) {
      console.warn(
        "[Reflag]",
        "Unable to open popover. Anchor must be an attached DOM-element"
      );
      return;
    }
  }
  Lt++, Kt(
    d(Yo, { ...t, position: n, key: Lt.toString() }),
    e
  );
}
const Go = (t = {}) => (e, n) => {
  n.openFeedbackForm(t);
};
async function mn(t, e, n) {
  if (!n.score && !n.comment) {
    e.error(
      "`feedback` call ignored, either `score` or `comment` must be provided"
    );
    return;
  }
  if (!n.userId) {
    e.error("`feedback` call ignored, no `userId` provided");
    return;
  }
  const o = "featureId" in n ? n.featureId : void 0, r = "flagKey" in n ? n.flagKey : void 0;
  if (!o && !r) {
    e.error(
      "`feedback` call ignored. Neither `featureId` nor `flagKey` have been provided"
    );
    return;
  }
  const i = {
    ...n,
    flagKey: void 0,
    source: n.source ?? "sdk",
    featureId: o,
    key: r
  }, s = await t.post({
    path: "/feedback",
    body: i
  });
  return e.debug("sent feedback", s), s;
}
class Qo {
  constructor(e, n, o, r = Go(), i, s = hn, a = {}) {
    this.sseBaseUrl = e, this.logger = n, this.httpClient = o, this.feedbackPromptHandler = r, this.userId = i, this.position = s, this.feedbackTranslations = a, this.initialized = !1, this.sseChannel = null;
  }
  /**
   * Start receiving automated feedback surveys.
   */
  async initialize() {
    if (this.initialized) {
      this.logger.error("auto. feedback client already initialized");
      return;
    }
    this.initialized = !0;
    const e = await this.getChannel();
    if (e)
      try {
        this.logger.debug("auto. feedback enabled", e), this.sseChannel = On({
          userId: this.userId,
          channel: e,
          httpClient: this.httpClient,
          callback: (n) => this.handleFeedbackPromptRequest(this.userId, n),
          logger: this.logger,
          sseBaseUrl: this.sseBaseUrl
        }), this.logger.debug("auto. feedback connection established");
      } catch (n) {
        this.logger.error("error initializing auto. feedback client", n);
      }
  }
  async getChannel() {
    const e = Dt(this.userId), n = e == null ? void 0 : e.channel;
    if (n)
      return n;
    try {
      if (!n) {
        const o = await this.httpClient.post({
          path: "/feedback/prompting-init",
          body: {
            userId: this.userId
          }
        });
        if (this.logger.debug("auto. feedback status sent", o), o.ok) {
          const r = await o.json();
          if (r.success && r.channel)
            return r.channel;
        }
      }
    } catch (o) {
      this.logger.error("error initializing auto. feedback", o);
      return;
    }
  }
  handleFeedbackPromptRequest(e, n) {
    const o = An(n);
    o ? Tn(e, o, async (r, i, s) => {
      await this.feedbackPromptEvent({
        promptId: o.promptId,
        featureId: o.featureId,
        promptedQuestion: o.question,
        event: "received",
        userId: e
      }), await this.triggerFeedbackPrompt(r, i, s);
    }) || this.logger.info(
      "feedback prompt not shown, it was either expired or already processed",
      n
    ) : this.logger.error("invalid feedback prompt message received", n);
  }
  stop() {
    this.sseChannel && (this.sseChannel.close(), this.sseChannel = null);
  }
  async triggerFeedbackPrompt(e, n, o) {
    let r;
    await this.feedbackPromptEvent({
      promptId: n.promptId,
      featureId: n.featureId,
      promptedQuestion: n.question,
      event: "shown",
      userId: e
    });
    const i = async (a) => {
      if (!a) {
        await this.feedbackPromptEvent({
          promptId: n.promptId,
          featureId: n.featureId,
          event: "dismissed",
          userId: e,
          promptedQuestion: n.question
        }), o();
        return;
      }
      const f = {
        feedbackId: r,
        featureId: n.featureId,
        userId: e,
        companyId: a.companyId,
        score: a.score,
        comment: a.comment,
        promptId: n.promptId,
        question: a.question,
        promptedQuestion: n.question,
        source: "prompt"
      }, c = await mn(
        this.httpClient,
        this.logger,
        f
      );
      if (o(), c && c.ok)
        return await (c == null ? void 0 : c.json());
    }, s = {
      reply: i,
      openFeedbackForm: (a) => {
        pn({
          key: n.featureId,
          title: n.question,
          onScoreSubmit: async (f) => {
            const c = await i(f);
            return r = c.feedbackId, { feedbackId: c.feedbackId };
          },
          onSubmit: async (f) => {
            var c;
            await i(f), (c = a.onAfterSubmit) == null || c.call(a, f);
          },
          onDismiss: () => i(null),
          position: this.position,
          translations: this.feedbackTranslations,
          ...a
        });
      }
    };
    this.feedbackPromptHandler(n, s);
  }
  async feedbackPromptEvent(e) {
    const n = {
      action: e.event,
      featureId: e.featureId,
      promptId: e.promptId,
      userId: e.userId,
      promptedQuestion: e.promptedQuestion
    }, o = await this.httpClient.post({
      path: "/feedback/prompt-events",
      body: n
    });
    return this.logger.debug("sent prompt event", o), o;
  }
}
const er = "1.1.0", bn = "https://front.reflag.com", tr = "https://app.reflag.com", nr = "https://livemessaging.bucket.co", Ot = "reflag-sdk-version", or = `browser-sdk/${er}`, rr = 1, ir = 30 * 24 * 60 * 60 * 1e3, sr = 60 * 1e3;
class ar {
  constructor(e, n) {
    this.eventsPerMinute = e, this.logger = n, this.eventsByKey = {};
  }
  rateLimited(e, n) {
    const o = Date.now();
    this.eventsByKey[e] || (this.eventsByKey[e] = []);
    const r = this.eventsByKey[e];
    for (; r.length && o - r[0] > sr; )
      r.shift();
    if (r.length >= this.eventsPerMinute) {
      this.logger.debug("Rate limit exceeded", { key: e });
      return;
    }
    return r.push(o), n();
  }
}
function _n(t) {
  if (!ue(t))
    return;
  const e = {};
  for (const n in t) {
    const o = t[n];
    if (typeof o.isEnabled != "boolean" || o.key !== n || typeof o.targetingVersion != "number" || o.config && typeof o.config != "object" || o.missingContextFields && !Array.isArray(o.missingContextFields) || o.ruleEvaluationResults && !Array.isArray(o.ruleEvaluationResults))
      return;
    e[n] = {
      isEnabled: o.isEnabled,
      targetingVersion: o.targetingVersion,
      key: n,
      config: o.config,
      missingContextFields: o.missingContextFields,
      ruleEvaluationResults: o.ruleEvaluationResults
    };
  }
  return e;
}
class lr {
  constructor({
    storage: e,
    staleTimeMs: n,
    expireTimeMs: o
  }) {
    this.storage = e, this.staleTimeMs = n, this.expireTimeMs = o;
  }
  set(e, {
    flags: n
  }) {
    let o = {};
    try {
      const r = this.storage.get();
      r && (o = At(JSON.parse(r)) ?? {});
    } catch {
    }
    return o[e] = {
      expireAt: Date.now() + this.expireTimeMs,
      staleAt: Date.now() + this.staleTimeMs,
      flags: n
    }, o = Object.fromEntries(
      Object.entries(o).filter(([r, i]) => i.expireAt > Date.now())
    ), this.storage.set(JSON.stringify(o)), o;
  }
  get(e) {
    try {
      const n = this.storage.get();
      if (n) {
        const o = At(JSON.parse(n));
        if (o && o[e] && o[e].expireAt > Date.now())
          return {
            flags: o[e].flags,
            stale: o[e].staleAt < Date.now()
          };
      }
    } catch {
    }
  }
}
function At(t) {
  if (!ue(t))
    return;
  const e = {};
  for (const n in t) {
    const o = t[n];
    if (!ue(o) || typeof o.expireAt != "number" || typeof o.staleAt != "number" || o.flags && !_n(o.flags))
      return;
    e[n] = {
      expireAt: o.expireAt,
      staleAt: o.staleAt,
      flags: o.flags
    };
  }
  return e;
}
function ue(t) {
  return t && typeof t == "object" && !Array.isArray(t);
}
const Tt = "flagsUpdated", cr = {
  fallbackFlags: {},
  timeoutMs: 5e3,
  staleWhileRevalidate: !1,
  offline: !1
};
function fr(t) {
  if (!ue(t) || typeof t.success != "boolean" || !ue(t.features))
    return;
  const e = _n(t.features);
  if (e)
    return {
      success: t.success,
      flags: e
    };
}
function yn(t) {
  const e = {};
  for (const n in t)
    if (typeof t[n] == "object") {
      const o = yn(t[n]);
      for (const r in o)
        e[`${n}.${r}`] = o[r];
    } else typeof t[n] < "u" && (e[n] = t[n]);
  return e;
}
const Mt = "__reflag_fetched_flags", vn = "__reflag_overrides";
function dr(t) {
  localStorage.setItem(vn, JSON.stringify(t));
}
function ur() {
  const t = JSON.parse(
    localStorage.getItem(vn) || "{}"
  );
  return ue(t) ? t : {};
}
class gr {
  constructor(e, n, o, r) {
    this.httpClient = e, this.context = n, this.flagOverrides = {}, this.flags = {}, this.eventTarget = new EventTarget(), this.abortController = new AbortController(), this.fetchedFlags = {}, this.logger = Je(o, "[Flags]"), this.cache = r != null && r.cache ? r.cache : new lr({
      storage: {
        get: () => localStorage.getItem(Mt),
        set: (s) => localStorage.setItem(Mt, s)
      },
      staleTimeMs: (r == null ? void 0 : r.staleTimeMs) ?? 0,
      expireTimeMs: (r == null ? void 0 : r.expireTimeMs) ?? ir
    });
    let i;
    Array.isArray(r == null ? void 0 : r.fallbackFlags) ? i = r.fallbackFlags.reduce(
      (s, a) => (s[a] = !0, s),
      {}
    ) : i = (r == null ? void 0 : r.fallbackFlags) ?? {}, this.config = {
      ...cr,
      ...r,
      fallbackFlags: i
    }, this.rateLimiter = (r == null ? void 0 : r.rateLimiter) ?? new ar(rr, this.logger);
    try {
      const s = ur();
      for (const a in s)
        this.flagOverrides[a] = s[a];
    } catch (s) {
      this.logger.warn("error getting flag overrides from cache", s), this.flagOverrides = {};
    }
  }
  async initialize() {
    const e = await this.maybeFetchFlags() || {};
    this.setFetchedFlags(e);
  }
  async setContext(e) {
    this.context = e, await this.initialize();
  }
  /**
   * Stop the client.
   */
  stop() {
    this.abortController.abort();
  }
  /**
   * Register a callback to be called when the flags are updated.
   * Flags are not guaranteed to have actually changed when the callback is called.
   *
   * @param callback this will be called when the flags are updated.
   * @returns a function that can be called to remove the listener
   */
  onUpdated(e) {
    this.eventTarget.addEventListener(Tt, e, {
      signal: this.abortController.signal
    });
  }
  getFlags() {
    return this.flags;
  }
  getFetchedFlags() {
    return this.fetchedFlags;
  }
  async fetchFlags() {
    const e = this.fetchParams();
    try {
      const n = await this.httpClient.get({
        path: "/features/evaluated",
        timeoutMs: this.config.timeoutMs,
        params: e
      });
      if (!n.ok) {
        let r = null;
        try {
          r = await n.json();
        } catch {
        }
        throw new Error(
          "unexpected response code: " + n.status + " - " + JSON.stringify(r)
        );
      }
      const o = fr(await n.json());
      if (!o || !o.success)
        throw new Error("unable to validate response");
      return o.flags;
    } catch (n) {
      this.logger.error("error fetching flags: ", n);
      return;
    }
  }
  /**
   * Send a flag "check" event.
   *
   *
   * @param checkEvent - The flag to send the event for.
   * @param cb - Callback to call after the event is sent. Might be skipped if the event was rate limited.
   */
  async sendCheckEvent(e, n) {
    if (this.config.offline)
      return;
    const o = `check-event:${this.fetchParams().toString()}:${e.key}:${e.version}:${e.value}`;
    return await this.rateLimiter.rateLimited(o, async () => {
      const r = {
        action: e.action,
        key: e.key,
        targetingVersion: e.version,
        evalContext: this.context,
        evalResult: e.value,
        evalRuleResults: e.ruleEvaluationResults,
        evalMissingFields: e.missingContextFields
      };
      this.httpClient.post({
        path: "features/events",
        body: r
      }).catch((i) => {
        this.logger.warn("failed to send flag check event", i);
      }), this.logger.debug("sent flag event", r), n();
    }), e.value;
  }
  triggerFlagsUpdated() {
    const e = {};
    for (const n in this.fetchedFlags) {
      const o = this.fetchedFlags[n];
      if (!o) continue;
      const r = this.flagOverrides[n] ?? null;
      e[n] = {
        ...o,
        isEnabledOverride: r
      };
    }
    this.flags = e, this.eventTarget.dispatchEvent(new Event(Tt));
  }
  setFetchedFlags(e) {
    this.fetchedFlags = e, this.triggerFlagsUpdated();
  }
  fetchParams() {
    const e = yn({ context: this.context }), n = new URLSearchParams(e);
    return n.append("publishableKey", this.httpClient.publishableKey), n.sort(), n;
  }
  warnMissingFlagContextFields(e) {
    var o, r, i;
    const n = {};
    for (const s in e) {
      const a = e[s];
      (o = a == null ? void 0 : a.missingContextFields) != null && o.length && (n[a.key] = a.missingContextFields), (i = (r = a == null ? void 0 : a.config) == null ? void 0 : r.missingContextFields) != null && i.length && (n[`${a.key}.config`] = a.config.missingContextFields);
    }
    Object.keys(n).length > 0 && this.rateLimiter.rateLimited(
      `flag-missing-context-fields:${this.fetchParams().toString()}`,
      () => {
        this.logger.warn(
          "flag targeting rules might not be correctly evaluated due to missing context fields.",
          n
        );
      }
    );
  }
  async maybeFetchFlags() {
    if (this.config.offline)
      return;
    const e = this.fetchParams().toString(), n = this.cache.get(e);
    if (n) {
      if (!n.stale) return n.flags;
      if (this.config.staleWhileRevalidate)
        return this.fetchFlags().then((r) => {
          r && (this.cache.set(e, {
            flags: r
          }), this.setFetchedFlags(r));
        }).catch(() => {
        }), n.flags;
    }
    const o = await this.fetchFlags();
    return o ? (this.cache.set(e, {
      flags: o
    }), this.warnMissingFlagContextFields(o), o) : n ? n.flags : Object.entries(this.config.fallbackFlags).reduce(
      (r, [i, s]) => (r[i] = {
        key: i,
        isEnabled: !!s,
        config: typeof s == "object" && "key" in s ? {
          key: s.key,
          payload: s.payload
        } : void 0
      }, r),
      {}
    );
  }
  setFlagOverride(e, n) {
    if (!(typeof n == "boolean" || n === null))
      throw new Error("setFlagOverride: isEnabled must be boolean or null");
    n === null ? delete this.flagOverrides[e] : this.flagOverrides[e] = n, dr(this.flagOverrides), this.triggerFlagsUpdated();
  }
  getFlagOverride(e) {
    return this.flagOverrides[e] ?? null;
  }
}
class hr {
  constructor() {
    this.hooks = {
      check: [],
      flagsUpdated: [],
      user: [],
      company: [],
      track: []
    };
  }
  _adjustEvent(e) {
    return e === "featuresUpdated" ? "flagsUpdated" : e;
  }
  addHook(e, n) {
    return this.hooks[this._adjustEvent(e)].push(n), () => {
      this.removeHook(e, n);
    };
  }
  removeHook(e, n) {
    this.hooks[this._adjustEvent(e)] = this.hooks[this._adjustEvent(e)].filter((o) => o !== n);
  }
  trigger(e, n) {
    this.hooks[this._adjustEvent(e)].forEach((o) => o(n));
  }
}
class pr {
  constructor(e, n = {}) {
    this.publishableKey = e, this.baseUrl = n.baseUrl ?? bn, this.baseUrl.endsWith("/") || (this.baseUrl += "/"), this.sdkVersion = n.sdkVersion ?? or, this.fetchOptions = { credentials: n.credentials };
  }
  getUrl(e) {
    return e.startsWith("/") && (e = e.slice(1)), new URL(e, this.baseUrl);
  }
  async get({
    path: e,
    params: n,
    timeoutMs: o
  }) {
    n || (n = new URLSearchParams()), n.set(Ot, this.sdkVersion), n.set("publishableKey", this.publishableKey);
    const r = this.getUrl(e);
    if (r.search = n.toString(), o === void 0)
      return fetch(r, this.fetchOptions);
    const i = new AbortController(), s = setTimeout(() => i.abort(), o), a = await fetch(r, {
      ...this.fetchOptions,
      signal: i.signal
    });
    return clearTimeout(s), a;
  }
  async post({
    path: e,
    body: n
  }) {
    return fetch(this.getUrl(e), {
      ...this.fetchOptions,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        [Ot]: this.sdkVersion,
        Authorization: `Bearer ${this.publishableKey}`
      },
      body: JSON.stringify(n)
    });
  }
}
const re = 1;
function mr({
  checked: t,
  width: e = 24,
  height: n = 14,
  ...o
}) {
  return /* @__PURE__ */ d(z, null, /* @__PURE__ */ d("label", { class: "switch", "data-enabled": t }, /* @__PURE__ */ d(
    "input",
    {
      checked: t,
      class: "switch-input",
      name: "enabled",
      type: "checkbox",
      ...o
    }
  ), /* @__PURE__ */ d(
    "div",
    {
      class: "switch-track",
      style: {
        width: `${e}px`,
        height: `${n}px`,
        borderRadius: `${n}px`
      }
    },
    /* @__PURE__ */ d(
      "div",
      {
        class: "switch-dot",
        style: {
          width: `${n - re * 2}px`,
          height: `${n - re * 2}px`,
          transform: t ? `translateX(${e - (n - re * 2) - re}px)` : `translateX(${re}px)`,
          top: `${re}px`
        }
      }
    )
  )));
}
const Ce = (t, e) => t.toLocaleLowerCase().includes(e ?? "");
function br({
  flags: t,
  searchQuery: e,
  appBaseUrl: n,
  setIsEnabledOverride: o
}) {
  const r = t.length > 0, i = t.some(
    (a) => Ce(a.flagKey, e)
  ), s = e === null ? t : [...t].sort((a, f) => {
    const c = Ce(a.flagKey, e), g = Ce(f.flagKey, e);
    if (c === g) {
      const l = a.flagKey.toLocaleLowerCase().startsWith(e), h = f.flagKey.toLocaleLowerCase().startsWith(e);
      return l && !h ? -1 : h && !l ? 1 : a.flagKey.localeCompare(f.flagKey);
    }
    return c ? -1 : 1;
  });
  return /* @__PURE__ */ d(z, null, (!r || !i) && /* @__PURE__ */ d("div", { class: "flags-table-empty" }, "No flags ", r ? `matching "${e}"` : "found"), /* @__PURE__ */ d("table", { class: "flags-table" }, /* @__PURE__ */ d("tbody", null, s.map((a, f) => /* @__PURE__ */ d(
    _r,
    {
      key: a.flagKey,
      appBaseUrl: n,
      flag: a,
      index: f,
      isNotVisible: e !== null && !Ce(a.flagKey, e),
      setEnabledOverride: (c) => o(a.flagKey, c)
    }
  )))));
}
function _r({
  setEnabledOverride: t,
  appBaseUrl: e,
  flag: n,
  index: o,
  isNotVisible: r
}) {
  return /* @__PURE__ */ d(
    "tr",
    {
      key: n.flagKey,
      class: ["flag-row", r ? "not-visible" : void 0].join(" ")
    },
    /* @__PURE__ */ d("td", { class: "flag-name-cell" }, /* @__PURE__ */ d(
      "a",
      {
        class: "flag-link",
        href: `${e}/env-current/flags/by-key/${n.flagKey}`,
        rel: "noreferrer",
        tabIndex: o + 1,
        target: "_blank"
      },
      n.flagKey
    )),
    /* @__PURE__ */ d("td", { class: "flag-reset-cell" }, n.localOverride !== null ? /* @__PURE__ */ d(vr, { setEnabledOverride: t, tabIndex: o + 1 }) : null),
    /* @__PURE__ */ d("td", { class: "flag-switch-cell" }, /* @__PURE__ */ d(
      mr,
      {
        checked: n.localOverride ?? n.isEnabled,
        tabIndex: o + 1,
        onChange: (i) => {
          const s = i.currentTarget.checked, a = s !== n.isEnabled;
          t(a ? s : null);
        }
      }
    ))
  );
}
function yr({ onSearch: t }) {
  return /* @__PURE__ */ d(
    "input",
    {
      class: "search-input",
      placeholder: "Search flags",
      tabIndex: 0,
      type: "search",
      autoFocus: !0,
      onInput: (e) => t(e.currentTarget.value)
    }
  );
}
function vr({
  setEnabledOverride: t,
  ...e
}) {
  return /* @__PURE__ */ d(
    "a",
    {
      class: "reset",
      href: "",
      onClick: (n) => {
        n.preventDefault(), t(null);
      },
      ...e
    },
    "reset"
  );
}
const xr = "@keyframes bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,50px,0) scaleY(2)}60%{opacity:1;transform:translate3d(0,-6px,0) scaleY(.9)}75%{transform:translate3d(0,3px,0) scaleY(.95)}90%{transform:translate3d(0,-2px,0) scaleY(.985)}to{transform:translateZ(0)}}@keyframes gelatine{0%,to{transform:scale(1)}25%{transform:scale(.9,1.1)}50%{transform:scale(1.1,.9)}75%{transform:scale(.95,1.05)}}.toolbar{--brand300: #9cc4d3;--brand400: #77adc1;--gray500: #787c91;--gray600: #3c3d49;--gray700: #22232a;--gray800: #17181c;--gray900: #0e0e11;--gray950: #09090b;--black: #1e1f24;--white: white;--bg-color: var(--gray900);--bg-light-color: var(--gray700);--border-color: var(--gray700);--dimmed-color: var(--gray500);--logo-color: white;--text-color: white;--text-size: 13px;--text-small-size: 12px;font-family:system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-size:13px;font-size:var(--text-size)}:focus{outline:none}.dialog{color:#fff;box-sizing:border-box;background:var(--bg-color);border:0;box-shadow:0 10px 15px -3px #00000026,0 4px 6px -2px #0000001a,0 -1px #ffffff1a,0 0 0 1px var(--border-color);border-radius:7px;z-index:999999;min-width:240px;padding:0;--visible-flags: 15;max-height:min(calc(100vh - 71px),450px);max-height:min(calc(100vh - 71px),calc(45px + (var(--visible-flags) * 27px)));height:auto}.dialog[open]{display:flex;flex-direction:column}.dialog-content{overflow-y:auto;max-height:100%;flex-grow:1;margin:3px 3px 3px 0}.dialog-content::-webkit-scrollbar{width:8px;height:8px}.dialog-content::-webkit-scrollbar-track{background:transparent}.dialog-content::-webkit-scrollbar-thumb{background-color:#fff3;border-radius:999px;-webkit-transition:background-color .1s ease;transition:background-color .1s ease}.dialog-content::-webkit-scrollbar-thumb:hover{background-color:#ffffff4d}.dialog-content::-webkit-scrollbar-button{display:none}.toolbar-toggle{width:36px;height:36px;position:fixed;z-index:999999;padding:0;margin:0;box-sizing:border-box;color:var(--logo-color);background:var(--bg-color);box-shadow:0 10px 15px -3px #00000026,0 4px 6px -2px #0000001a,0 -1px #ffffff1a,0 0 0 1px var(--border-color);border-radius:999px;cursor:pointer;display:flex;justify-content:center;align-items:center;animation:bounceInUp .2s ease-out;transition:background .1s ease}.toolbar-toggle.open{background:var(--bg-light-color)}.toolbar-toggle .override-indicator{position:absolute;top:1px;right:1px;width:8px;height:8px;background-color:var(--brand400);border-radius:50%;opacity:0;transition:opacity .1s ease-in-out;box-shadow:inset 0 1px #ffffff1a}.toolbar-toggle .override-indicator.show{opacity:1;animation:gelatine .5s}.toolbar-header-button{background:none;border:none;color:var(--dimmed-color);cursor:pointer;border-radius:4px;transition:background-color .1s ease;flex-shrink:0;display:flex;align-items:center;justify-content:center;height:28px;width:28px}.toolbar-header-button:hover{background-color:var(--bg-light-color);color:var(--text-color)}.toolbar-header-button:focus-visible{outline:1px solid #fff;outline-offset:0px}.toolbar-header-button+.button-tooltip{pointer-events:none;opacity:0;background:var(--bg-color);color:var(--text-color);padding:6px 8px;border-radius:4px;font-size:13px}.toolbar-header-button:hover+.button-tooltip{opacity:1}[data-tooltip]{position:relative}[data-tooltip]:after{content:attr(data-tooltip);position:absolute;right:100%;top:0%;margin-right:3px;-webkit-user-select:none;-moz-user-select:none;user-select:none;pointer-events:none;background-color:var(--bg-color);border:1px solid var(--border-color);border-radius:4px;padding:0 6px;height:28px;line-height:26px;color:var(--text-color);font-size:var(--text-small-size);font-weight:400;width:-moz-max-content;width:max-content;display:none;box-sizing:border-box}[data-tooltip]:hover:after{display:block}.search-input{background:transparent;border:none;color:#fff;width:100%;font-size:var(--text-size);height:28px}.search-input::-moz-placeholder{color:var(--gray500)}.search-input::placeholder{color:var(--gray500)}.search-input::-webkit-search-cancel-button{-webkit-appearance:none;display:inline-block;width:8px;height:8px;margin-left:10px;background:linear-gradient(45deg,#0000,#0000 43%,#fff 45%,#fff 55%,#0000 57%,#0000),linear-gradient(135deg,transparent 0%,transparent 43%,#fff 45%,#fff 55%,transparent 57%,transparent 100%);cursor:pointer}.flags-table{width:100%;border-collapse:collapse}.flag-row.not-visible{visibility:hidden}.flags-table-empty{position:absolute;top:0;left:0;right:0;color:var(--gray500);padding:12px;line-height:1.5}.flag-name-cell{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:auto;padding:6px 6px 6px 0;display:flex;align-items:center;gap:8px}.flag-name-cell .flag-icon{height:15px;width:15px;color:var(--dimmed-color)}.flag-link{color:var(--text-color);-webkit-text-decoration:none;text-decoration:none}.flag-link:hover,.flag-link:focus-visible{-webkit-text-decoration:underline;text-decoration:underline}.flag-reset-cell{width:32px;padding:6px 0;text-align:right}.reset{color:var(--gray500);-webkit-text-decoration:none;text-decoration:none}.reset:hover,.reset:focus-visible{-webkit-text-decoration:underline;text-decoration:underline}.flag-switch-cell{padding:6px 0 6px 6px;width:0}.switch{cursor:pointer;position:relative}.switch-input{border:0px;clip:rect(0px,0px,0px,0px);height:1px;width:1px;margin:-1px;padding:0;overflow:hidden;white-space:nowrap;position:absolute}.switch-track{position:relative;transition:background .1s ease;background:var(--gray600);border-radius:999px;transition:transform .1s ease-out}.switch-input:focus-visible+.switch-track{outline:1px solid #fff;outline-offset:1px}.switch[data-enabled=true] .switch-track{background:#fff}.switch-dot{background:#fff;border-radius:50%;position:absolute;top:1px;transition:transform .1s ease-out;box-shadow:0 0 5px #0003}.switch[data-enabled=true] .switch-dot{background:var(--black)}", Pt = "reflag-toolbar-hidden";
function wr({
  reflagClient: t,
  position: e
}) {
  var w;
  const n = U(null), o = U(null), [r, i] = A([]), s = ((w = window == null ? void 0 : window.sessionStorage) == null ? void 0 : w.getItem(Pt)) === "true", [a, f] = A(s), c = P(() => {
    const x = t.getFlags();
    i(
      Object.values(x).filter((k) => k !== void 0).map(
        (k) => ({
          flagKey: k.key,
          localOverride: k.isEnabledOverride,
          isEnabled: k.isEnabled
        })
      )
    );
  }, [t]), g = Q(() => r.some((x) => x.localOverride !== null), [r]);
  le(() => {
    c(), t.on("flagsUpdated", c);
  }, [t, c]);
  const [l, h] = A(null), u = (x) => {
    var k;
    h(x === "" ? null : x), (k = o.current) == null || k.scrollTo({ top: 0 });
  }, m = [...r].sort(
    (x, k) => x.flagKey.localeCompare(k.flagKey)
  ), _ = t.getConfig().appBaseUrl, { isOpen: b, close: p, toggle: y } = dn(), v = P(() => {
    var x;
    (x = window == null ? void 0 : window.sessionStorage) == null || x.setItem(Pt, "true"), f(!0), p();
  }, [p]);
  return a ? null : /* @__PURE__ */ d("div", { class: "toolbar" }, /* @__PURE__ */ d("style", { dangerouslySetInnerHTML: { __html: xr } }), /* @__PURE__ */ d(
    kr,
    {
      hasAnyOverrides: g,
      innerRef: n,
      isOpen: b,
      position: e,
      onClick: y
    }
  ), /* @__PURE__ */ d(
    un,
    {
      close: p,
      containerId: Zt,
      isOpen: b,
      position: {
        type: "POPOVER",
        anchor: n.current,
        placement: "top-start"
      },
      showArrow: !1,
      strategy: "fixed"
    },
    /* @__PURE__ */ d(Ro, null, /* @__PURE__ */ d(yr, { onSearch: u }), /* @__PURE__ */ d(
      "a",
      {
        class: "toolbar-header-button",
        "data-tooltip": "Open Reflag app",
        href: `${_}/env-current`
      },
      /* @__PURE__ */ d(
        "svg",
        {
          width: "15",
          height: "15",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          fill: "currentColor"
        },
        /* @__PURE__ */ d("path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9.71002 19.6674C8.74743 17.6259 8.15732 15.3742 8.02731 13H4.06189C4.458 16.1765 6.71639 18.7747 9.71002 19.6674ZM10.0307 13C10.1811 15.4388 10.8778 17.7297 12 19.752C13.1222 17.7297 13.8189 15.4388 13.9693 13H10.0307ZM19.9381 13H15.9727C15.8427 15.3742 15.2526 17.6259 14.29 19.6674C17.2836 18.7747 19.542 16.1765 19.9381 13ZM4.06189 11H8.02731C8.15732 8.62577 8.74743 6.37407 9.71002 4.33256C6.71639 5.22533 4.458 7.8235 4.06189 11ZM10.0307 11H13.9693C13.8189 8.56122 13.1222 6.27025 12 4.24799C10.8778 6.27025 10.1811 8.56122 10.0307 11ZM14.29 4.33256C15.2526 6.37407 15.8427 8.62577 15.9727 11H19.9381C19.542 7.8235 17.2836 5.22533 14.29 4.33256Z" })
      )
    ), /* @__PURE__ */ d(
      "button",
      {
        class: "toolbar-header-button",
        onClick: v,
        "data-tooltip": "Hide toolbar this session"
      },
      /* @__PURE__ */ d(
        "svg",
        {
          width: "15",
          height: "15",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          fill: "currentColor"
        },
        /* @__PURE__ */ d("path", { d: "M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z" })
      )
    )),
    /* @__PURE__ */ d(Eo, { innerRef: o }, /* @__PURE__ */ d(
      br,
      {
        appBaseUrl: _,
        flags: m,
        searchQuery: (l == null ? void 0 : l.toLocaleLowerCase()) ?? null,
        setIsEnabledOverride: (x, k) => t.getFlag(x).setIsEnabledOverride(k)
      }
    ))
  ));
}
function kr({
  isOpen: t,
  position: e,
  onClick: n,
  innerRef: o,
  hasAnyOverrides: r
}) {
  const i = at(e), s = ["toolbar-toggle", t ? "open" : void 0].join(
    " "
  ), a = [
    "override-indicator",
    r ? "show" : void 0
  ].join(" ");
  return /* @__PURE__ */ d("div", { ref: o, class: s, style: i, onClick: n }, /* @__PURE__ */ d("div", { class: a }), /* @__PURE__ */ d(gn, { height: "13px", width: "13px" }));
}
const Cr = "bottom-right";
function Sr(t) {
  const e = So(Zt), n = t.position ?? {
    placement: Cr
  };
  Kt(d(wr, { ...t, position: n }), e);
}
const Fr = typeof window < "u" && window.innerWidth < 768, Rr = typeof document > "u", he = {
  apiBaseUrl: bn,
  appBaseUrl: tr,
  sseBaseUrl: nr,
  enableTracking: !0,
  offline: !1
};
function Er(t) {
  var n;
  const e = t.toolbar;
  return typeof e == "boolean" ? e : typeof (e == null ? void 0 : e.show) == "boolean" ? e.show : ((n = window == null ? void 0 : window.location) == null ? void 0 : n.hostname) === "localhost";
}
class Ir {
  /**
   * Create a new ReflagClient instance.
   */
  constructor(e) {
    var n, o, r, i, s, a, f, c, g, l, h, u, m, _;
    this.publishableKey = e.publishableKey, this.logger = (e == null ? void 0 : e.logger) ?? Je(Rn, "[Reflag]"), this.context = {
      user: (n = e == null ? void 0 : e.user) != null && n.id ? e.user : void 0,
      company: (o = e == null ? void 0 : e.company) != null && o.id ? e.company : void 0,
      otherContext: e == null ? void 0 : e.otherContext
    }, this.config = {
      apiBaseUrl: (e == null ? void 0 : e.apiBaseUrl) ?? he.apiBaseUrl,
      appBaseUrl: (e == null ? void 0 : e.appBaseUrl) ?? he.appBaseUrl,
      sseBaseUrl: (e == null ? void 0 : e.sseBaseUrl) ?? he.sseBaseUrl,
      enableTracking: (e == null ? void 0 : e.enableTracking) ?? he.enableTracking,
      offline: (e == null ? void 0 : e.offline) ?? he.offline
    }, this.requestFeedbackOptions = {
      position: (i = (r = e == null ? void 0 : e.feedback) == null ? void 0 : r.ui) == null ? void 0 : i.position,
      translations: (a = (s = e == null ? void 0 : e.feedback) == null ? void 0 : s.ui) == null ? void 0 : a.translations
    }, this.httpClient = new pr(this.publishableKey, {
      baseUrl: this.config.apiBaseUrl,
      sdkVersion: e == null ? void 0 : e.sdkVersion,
      credentials: e == null ? void 0 : e.credentials
    }), this.flagsClient = new gr(
      this.httpClient,
      // API expects `other` and we have `otherContext`.
      {
        user: this.context.user,
        company: this.context.company,
        other: this.context.otherContext
      },
      this.logger,
      {
        expireTimeMs: e.expireTimeMs,
        staleTimeMs: e.staleTimeMs,
        fallbackFlags: e.fallbackFlags,
        timeoutMs: e.timeoutMs,
        offline: this.config.offline
      }
    ), !this.config.offline && ((f = this.context) != null && f.user) && !Rr && // do not prompt on server-side
    ((c = e == null ? void 0 : e.feedback) == null ? void 0 : c.enableAutoFeedback) !== !1 && (Fr ? this.logger.warn(
      "Feedback prompting is not supported on mobile devices"
    ) : this.autoFeedback = new Qo(
      this.config.sseBaseUrl,
      this.logger,
      this.httpClient,
      (g = e == null ? void 0 : e.feedback) == null ? void 0 : g.autoFeedbackHandler,
      String((l = this.context.user) == null ? void 0 : l.id),
      (u = (h = e == null ? void 0 : e.feedback) == null ? void 0 : h.ui) == null ? void 0 : u.position,
      (_ = (m = e == null ? void 0 : e.feedback) == null ? void 0 : m.ui) == null ? void 0 : _.translations
    )), Er(e) && (this.logger.info("opening toolbar toggler"), Sr({
      reflagClient: this,
      position: typeof e.toolbar == "object" ? e.toolbar.position : void 0
    })), this.hooks = new hr(), this.flagsClient.onUpdated(() => {
      this.hooks.trigger("flagsUpdated", this.flagsClient.getFlags());
    });
  }
  /**
   * Initialize the Reflag SDK.
   *
   * Must be called before calling other SDK methods.
   */
  async initialize() {
    const e = Date.now();
    this.autoFeedback && (this.autoFeedbackInit = this.autoFeedback.initialize().catch((n) => {
      this.logger.error("error initializing automated feedback surveys", n);
    })), await this.flagsClient.initialize(), this.context.user && this.config.enableTracking && this.user().catch((n) => {
      this.logger.error("error sending user", n);
    }), this.context.company && this.config.enableTracking && this.company().catch((n) => {
      this.logger.error("error sending company", n);
    }), this.logger.info(
      "Reflag initialized in " + Math.round(Date.now() - e) + "ms" + (this.config.offline ? " (offline mode)" : "")
    );
  }
  /**
   * Add an event listener
   *
   * @param type Type of events to listen for
   * @param handler The function to call when the event is triggered.
   * @returns A function to remove the hook.
   */
  on(e, n) {
    return this.hooks.addHook(e, n);
  }
  /**
   * Remove an event listener
   *
   * @param type Type of event to remove.
   * @param handler The same function that was passed to `on`.
   *
   * @returns A function to remove the hook.
   */
  off(e, n) {
    this.hooks.removeHook(e, n);
  }
  /**
   * Get the current configuration.
   */
  getConfig() {
    return this.config;
  }
  /**
   * Update the user context.
   * Performs a shallow merge with the existing user context.
   * Attempting to update the user ID will log a warning and be ignored.
   *
   * @param user
   */
  async updateUser(e) {
    var n, o;
    if (e.id && e.id !== ((n = this.context.user) == null ? void 0 : n.id)) {
      this.logger.warn(
        "ignoring attempt to update the user ID. Re-initialize the ReflagClient with a new user ID instead."
      );
      return;
    }
    this.context.user = {
      ...this.context.user,
      ...e,
      id: e.id ?? ((o = this.context.user) == null ? void 0 : o.id)
    }, this.user(), await this.flagsClient.setContext(this.context);
  }
  /**
   * Update the company context.
   * Performs a shallow merge with the existing company context.
   * Attempting to update the company ID will log a warning and be ignored.
   *
   * @param company The company details.
   */
  async updateCompany(e) {
    var n, o;
    if (e.id && e.id !== ((n = this.context.company) == null ? void 0 : n.id)) {
      this.logger.warn(
        "ignoring attempt to update the company ID. Re-initialize the ReflagClient with a new company ID instead."
      );
      return;
    }
    this.context.company = {
      ...this.context.company,
      ...e,
      id: e.id ?? ((o = this.context.company) == null ? void 0 : o.id)
    }, this.company(), await this.flagsClient.setContext(this.context);
  }
  /**
   * Update the company context.
   * Performs a shallow merge with the existing company context.
   * Updates to the company ID will be ignored.
   *
   * @param otherContext Additional context.
   */
  async updateOtherContext(e) {
    this.context.otherContext = {
      ...this.context.otherContext,
      ...e
    }, await this.flagsClient.setContext(this.context);
  }
  /**
   * Track an event in Reflag.
   *
   * @param eventName The name of the event.
   * @param attributes Any attributes you want to attach to the event.
   */
  async track(e, n) {
    var i, s;
    if (!this.context.user) {
      this.logger.warn("'track' call ignored. No user context provided");
      return;
    }
    if (!this.config.enableTracking) {
      this.logger.warn("'track' call ignored. 'enableTracking' is false");
      return;
    }
    if (this.config.offline)
      return;
    const o = {
      userId: String(this.context.user.id),
      event: e
    };
    n && (o.attributes = n), (i = this.context.company) != null && i.id && (o.companyId = String((s = this.context.company) == null ? void 0 : s.id));
    const r = await this.httpClient.post({ path: "/event", body: o });
    return this.logger.debug("sent event", r), this.hooks.trigger("track", {
      eventName: e,
      attributes: n,
      user: this.context.user,
      company: this.context.company
    }), r;
  }
  /**
   * Submit user feedback to Reflag. Must include either `score` or `comment`, or both.
   *
   * @param payload The feedback details to submit.
   * @returns The server response.
   */
  async feedback(e) {
    var r, i, s, a;
    if (this.config.offline)
      return;
    const n = e.userId || ((r = this.context.user) != null && r.id ? String((i = this.context.user) == null ? void 0 : i.id) : void 0), o = e.companyId || ((s = this.context.company) != null && s.id ? String((a = this.context.company) == null ? void 0 : a.id) : void 0);
    return await mn(this.httpClient, this.logger, {
      userId: n,
      companyId: o,
      ...e
    });
  }
  /**
   * Display the Reflag feedback form UI programmatically.
   *
   * This can be used to collect feedback from users in Reflag in cases where Automated Feedback Surveys isn't appropriate.
   *
   * @param options
   */
  requestFeedback(e) {
    var o, r, i;
    if (!((o = this.context.user) != null && o.id)) {
      this.logger.error(
        "`requestFeedback` call ignored. No `user` context provided at initialization"
      );
      return;
    }
    if (!e.flagKey) {
      this.logger.error(
        "`requestFeedback` call ignored. No `flagKey` provided"
      );
      return;
    }
    const n = {
      flagKey: e.flagKey,
      companyId: e.companyId || ((r = this.context.company) != null && r.id ? String((i = this.context.company) == null ? void 0 : i.id) : void 0),
      source: "widget"
    };
    setTimeout(() => {
      pn({
        key: e.flagKey,
        title: e.title,
        position: e.position || this.requestFeedbackOptions.position,
        translations: e.translations || this.requestFeedbackOptions.translations,
        openWithCommentVisible: e.openWithCommentVisible,
        onClose: e.onClose,
        onDismiss: e.onDismiss,
        onScoreSubmit: async (s) => {
          const a = await this.feedback({
            ...n,
            ...s
          });
          return a ? { feedbackId: (await a.json()).feedbackId } : { feedbackId: void 0 };
        },
        onSubmit: async (s) => {
          var a;
          await this.feedback({
            ...n,
            ...s
          }), (a = e.onAfterSubmit) == null || a.call(e, s);
        }
      });
    }, 1);
  }
  /**
   * @deprecated Use `getFlags` instead.
   */
  getFeatures() {
    return this.getFlags();
  }
  /**
   * Returns a map of enabled flags.
   * Accessing a flag will *not* send a check event
   * and `isEnabled` does not take any flag overrides
   * into account.
   *
   * @returns Map of flags.
   */
  getFlags() {
    return this.flagsClient.getFlags();
  }
  /**
   * @deprecated Use `getFlag` instead.
   */
  getFeature(e) {
    return this.getFlag(e);
  }
  /**
   * Return a flag. Accessing `isEnabled` or `config` will automatically send a `check` event.
   *
   * @param flagKey - The key of the flag to get.
   * @returns A flag.
   */
  getFlag(e) {
    const n = this.getFlags()[e], o = this, r = (n == null ? void 0 : n.isEnabledOverride) ?? (n == null ? void 0 : n.isEnabled) ?? !1, i = n != null && n.config ? {
      key: n.config.key,
      payload: n.config.payload
    } : { key: void 0, payload: void 0 };
    return {
      get isEnabled() {
        return o.sendCheckEvent({
          action: "check-is-enabled",
          key: e,
          version: n == null ? void 0 : n.targetingVersion,
          ruleEvaluationResults: n == null ? void 0 : n.ruleEvaluationResults,
          missingContextFields: n == null ? void 0 : n.missingContextFields,
          value: r
        }).catch(() => {
        }), r;
      },
      get config() {
        var s, a, f;
        return o.sendCheckEvent({
          action: "check-config",
          key: e,
          version: (s = n == null ? void 0 : n.config) == null ? void 0 : s.version,
          ruleEvaluationResults: (a = n == null ? void 0 : n.config) == null ? void 0 : a.ruleEvaluationResults,
          missingContextFields: (f = n == null ? void 0 : n.config) == null ? void 0 : f.missingContextFields,
          value: (n == null ? void 0 : n.config) && {
            key: n.config.key,
            payload: n.config.payload
          }
        }).catch(() => {
        }), i;
      },
      track: () => this.track(e),
      requestFeedback: (s) => {
        this.requestFeedback({
          flagKey: e,
          ...s
        });
      },
      isEnabledOverride: this.flagsClient.getFlagOverride(e),
      setIsEnabledOverride(s) {
        o.flagsClient.setFlagOverride(e, s);
      }
    };
  }
  sendCheckEvent(e) {
    return this.flagsClient.sendCheckEvent(e, () => {
      this.hooks.trigger("check", e);
    });
  }
  /**
   * Stop the SDK.
   * This will stop any automated feedback surveys.
   *
   **/
  async stop() {
    this.autoFeedback && (await this.autoFeedbackInit, this.autoFeedback.stop()), this.flagsClient.stop();
  }
  /**
   * Send attributes to Reflag for the current user
   */
  async user() {
    if (!this.context.user) {
      this.logger.warn(
        "`user` call ignored. No user context provided at initialization"
      );
      return;
    }
    if (this.config.offline)
      return;
    const { id: e, ...n } = this.context.user, o = {
      userId: String(e),
      attributes: n
    }, r = await this.httpClient.post({ path: "/user", body: o });
    return this.logger.debug("sent user", r), this.hooks.trigger("user", this.context.user), r;
  }
  /**
   * Send attributes to Reflag for the current company.
   */
  async company() {
    if (!this.context.user) {
      this.logger.warn(
        "`company` call ignored. No user context provided at initialization"
      );
      return;
    }
    if (!this.context.company) {
      this.logger.warn(
        "`company` call ignored. No company context provided at initialization"
      );
      return;
    }
    if (this.config.offline)
      return;
    const { id: e, ...n } = this.context.company, o = {
      userId: String(this.context.user.id),
      companyId: String(e),
      attributes: n
    }, r = await this.httpClient.post({ path: "/company", body: o });
    return this.logger.debug("sent company", r), this.hooks.trigger("company", this.context.company), r;
  }
}
export {
  Ir as ReflagClient,
  Ze as feedbackContainerId,
  Wt as propagatedEvents
};
//# sourceMappingURL=reflag-browser-sdk.mjs.map
